// src/pages/Admin/pages/UserManagement/UserManagement.jsx
import React, { useEffect, useState } from "react";
import styles from "./UserManagement.module.css";

const API_BASE_URL = "https://final-project-5ar7.onrender.com"; // ✅ module-level

export default function UserManagement() {
  const [pendingUsers, setPendingUsers] = useState([]);
  const [approvedUsers, setApprovedUsers] = useState([]);
  const [kycProfiles, setKycProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);
  const [activeTab, setActiveTab] = useState('approved'); // 'pending', 'approved', 'kyc'
  const [selectedUser, setSelectedUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
 const [newPin, setNewPin] = useState({});
  const [newPassword, setNewPassword] = useState('');
const [confirmNewPassword, setConfirmNewPassword] = useState('');

  // âœ… NEW: Trading account editing states
  const [editingAccountId, setEditingAccountId] = useState(null);
  const [editValues, setEditValues] = useState({});

  // âœ… NEW: Prevent refresh during editing
  const [isEditing, setIsEditing] = useState(false);
  const [editingTimeout, setEditingTimeout] = useState(null);
// âœ… NEW: Trading platform visibility for admin
const [allOpenPositions, setAllOpenPositions] = useState([]);
const [liveUserAccounts, setLiveUserAccounts] = useState([]);
const [refreshInterval, setRefreshInterval] = useState(null);

// âœ… FIXED: Handle undefined opts parameter
const API_BASE_URL = "https://final-project-5ar7.onrender.com";

const api = (path, opts = {}) => {  // â† ADD DEFAULT EMPTY OBJECT HERE
  const token = localStorage.getItem("userToken");
  
  // âœ… FIXED: Remove double slash - path already starts with /
  const fullURL = `${API_BASE_URL}/api/admin${path}`;
  
  console.log('API Call Debug:', {
    path: path,
    hasToken: !!token,
    tokenPreview: token ? token.substring(0, 20) + "..." : "NO TOKEN",
    fullURL: fullURL
  });
  
  return fetch(fullURL, {
    ...opts,
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
      ...(opts.headers || {}),  // â† ADD SAFE ACCESS HERE TOO
    },
  });
};




  // âœ… FIXED: Don't refresh during editing
  const fetchUsers = async () => {
    if (isEditing) {
      console.log('Skipping refresh - user is editing');
      return;
    }
    
    try {
      setLoading(true);
      const [pRes, aRes, kRes, tRes] = await Promise.all([
        api("/public/pending-users"),
        api("/public/approved-users"),
        api("/public/all-kyc-profiles"),
        api("/public/all-trading-accounts") // Get all trading accounts
      ]);
      
      const pendingData = await pRes.json();
      const approvedData = await aRes.json();
      const kycData = await kRes.json();
      const tradingData = await tRes.json();
      
      // Calculate trading account balance for each user
      const approvedWithBalance = approvedData.map(user => {
        const userAccounts = tradingData.filter(acc => 
          acc.userId._id === user._id && acc.adminStatus === 'approved'
        );
        const tradingAccountBalance = userAccounts.reduce((sum, acc) => 
          sum + parseFloat(acc.balance || 0), 0
        );
        
        return {
          ...user,
          tradingAccountBalance
        };
      });
      
      setPendingUsers(Array.isArray(pendingData) ? pendingData : []);
      setApprovedUsers(approvedWithBalance);
      setKycProfiles(Array.isArray(kycData) ? kycData : []);
    } catch (e) {
      console.error("Error fetching users:", e);
      setPendingUsers([]);
      setApprovedUsers([]);
      setKycProfiles([]);
    } finally {
      setLoading(false);
    }
  };

// âœ… FIXED: fetchLiveTradingData function
const fetchLiveTradingData = async () => {
  try {
    // Get all open positions
    const positionsResponse = await api("/public/all-open-positions");
    
    // âœ… FIXED: Check if response is ok
    if (!positionsResponse.ok) {
      throw new Error(`HTTP ${positionsResponse.status}: ${positionsResponse.statusText}`);
    }
    
    const positionsData = await positionsResponse.json();
    
    console.log('Live positions data:', positionsData);
    
    // âœ… FIXED: Handle the correct response structure
    const positions = positionsData.success ? positionsData.positions : [];
    setAllOpenPositions(positions || []);

    // Get all live accounts
    const accountsResponse = await api("/public/all-live-accounts");
    
    if (!accountsResponse.ok) {
      throw new Error(`HTTP ${accountsResponse.status}: ${accountsResponse.statusText}`);
    }
    
    const accountsData = await accountsResponse.json();
    
    console.log('Live accounts data:', accountsData);
    
    // âœ… FIXED: accountsData is directly an array
    setLiveUserAccounts(Array.isArray(accountsData) ? accountsData : []);
    
  } catch (error) {
    console.error('âŒ Error fetching live trading data:', error);
    // Set empty arrays on error
    setAllOpenPositions([]);
    setLiveUserAccounts([]);
  }
};


  useEffect(() => {
    fetchUsers();
  }, [refreshKey]);

  // âœ… FIXED: Pause auto-refresh during editing
  useEffect(() => {
    //const id = setInterval(() => {
     // if (!isEditing) {
       // fetchUsers();
     //// } else {
       // console.log('â¸ï¸ Auto-refresh paused - user is editing');
     // }
   // }, 30_000);
    //return () => clearInterval(id);
  }, [isEditing]);

useEffect(() => {
  fetchLiveTradingData();
  // Only poll when on the trading tab, and use 10s not 3s
  if (activeTab !== 'trading') return;
  const interval = setInterval(fetchLiveTradingData, 10000);
  setRefreshInterval(interval);
  return () => {
    if (interval) clearInterval(interval);
  };
}, [activeTab]);  // ← re-runs when tab changes[]);

  // âœ… UPDATED: Fetch complete user profile with referral data - don't refresh during editing
  const fetchUserProfile = async (userId, forceRefresh = false) => {
    if (isEditing && !forceRefresh) {
      console.log('Skipping profile refresh - user is editing');
      return;
    }

    try {
      const [profileResponse, referralResponse] = await Promise.all([
        api(`/public/user-profile/${userId}`),
        api(`/public/user-referrals/${userId}`)
      ]);
      
      const profileData = await profileResponse.json();
      const referralData = referralResponse.ok ? await referralResponse.json() : { success: false };

      if (profileData.success) {
        // âœ… NEW: Recalculate total free margin from current trading accounts
        const totalFreeMargin = profileData.userProfile.tradingAccounts
          .filter(acc => acc.adminStatus === 'approved')
          .reduce((sum, acc) => sum + parseFloat(acc.freeMargin || acc.equity || acc.balance || 0), 0);
        
        // âœ… Update the stats with recalculated total
        profileData.userProfile.stats.totalFreeMargin = totalFreeMargin;
        
        // âœ… NEW: Add referral data
        profileData.userProfile.referralData = referralData.success ? referralData.data : {
          level: 1,
          totalReferrals: 0,
          commission: 0,
          referrals: []
        };
        
        setUserProfile(profileData.userProfile);
        setSelectedUser(userId);
        console.log('User profile loaded with referral data:', profileData.userProfile);
      } else {
        alert('âŒ Failed to load user profile');
      }
    } catch (error) {
      console.error('âŒ Error fetching user profile:', error);
      alert('âŒ Network error while loading user profile');
    }
  };

  // âœ… NEW: Helper to manage editing state
  const handleEditingState = (callback) => {
    if (editingTimeout) clearTimeout(editingTimeout);
    setIsEditing(true);
    const timeout = setTimeout(() => {
      setIsEditing(false);
      console.log('Editing completed - auto-refresh resumed');
    }, 3000); // 3 seconds after last edit
    setEditingTimeout(timeout);
    if (callback) callback();
  };

  // âœ… NEW: Reset user PIN
  const handleResetPin = async (userId) => {
    if (!newPin || newPin.length < 4) {
      alert('âŒ PIN must be at least 4 digits');
      return;
    }

    try {
      const response = await api(`/public/reset-user-pin/${userId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          newPin: newPin,
          adminNotes: `PIN reset due to admin action - Original PIN forgotten`
        })
      });

      if (response.ok) {
        alert('âœ… User PIN reset successfully!');
        setNewPin('');
        await fetchUserProfile(userId, true); // Force refresh
        setRefreshKey(k => k + 1);
      } else {
        const error = await response.json();
        alert(`âŒ Error resetting PIN: ${error.message}`);
      }
    } catch (error) {
      console.error('âŒ Error resetting PIN:', error);
      alert('âŒ Network error occurred');
    }
  };
  // ✅ NEW: Reset user account password
const handleResetPassword = async (userId) => {
  if (!newPassword || newPassword.length < 6) {
    alert('❌ Password must be at least 6 characters');
    return;
  }
  if (newPassword !== confirmNewPassword) {
    alert('❌ Passwords do not match');
    return;
  }
  if (!window.confirm(`Reset login password for this user?`)) return;

  try {
    const response = await api(`/public/reset-user-password/${userId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ newPassword })
    });

    if (response.ok) {
      alert('✅ User password reset successfully!');
      setNewPassword('');
      setConfirmNewPassword('');
    } else {
      const error = await response.json();
      alert(`❌ Error: ${error.message}`);
    }
  } catch (error) {
    console.error('❌ Error resetting password:', error);
    alert('❌ Network error occurred');
  }
};

  // âœ… NEW: Edit transaction amounts
  const handleEditTransaction = async (type, transactionId, currentAmount) => {
    const newAmount = prompt(`Edit ${type} amount:`, currentAmount);
    if (!newAmount || parseFloat(newAmount) <= 0) return;

    const adminNotes = prompt('Admin notes (optional):', '');

    try {
      const endpoint = type === 'deposit' 
        ? `/public/edit-deposit/${transactionId}`
        : `/public/edit-withdrawal/${transactionId}`;

      const response = await api(endpoint, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          newAmount: parseFloat(newAmount),
          adminNotes: adminNotes
        })
      });

      if (response.ok) {
        alert(`âœ… ${type} amount updated successfully!`);
        if (selectedUser) {
          await fetchUserProfile(selectedUser, true); // Force refresh
        }
        setRefreshKey(k => k + 1);
      } else {
        const error = await response.json();
        alert(`âŒ Error: ${error.message}`);
      }
    } catch (error) {
      console.error(`âŒ Error editing ${type}:`, error);
      alert('âŒ Network error occurred');
    }
  };
// ✅ NEW: Edit withdrawal amount and recalculate
const handleEditWithdrawal = async (withdrawalId, currentAmount, currentStatus) => {
  const newAmount = prompt(`Edit Withdrawal Amount\n\nCurrent: $${currentAmount}\nStatus: ${currentStatus}\n\nEnter new amount:`, currentAmount);
  
  if (!newAmount || parseFloat(newAmount) <= 0) {
    return;
  }

  const adminNotes = prompt('Admin notes (optional):', `Amount edited from $${currentAmount} to $${newAmount}`);

  try {
    const response = await api(`/public/edit-withdrawal/${withdrawalId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        newAmount: parseFloat(newAmount),
        adminNotes: adminNotes
      })
    });

    if (response.ok) {
      const result = await response.json();
      alert(`✅ Withdrawal updated successfully!\n\nOld Amount: $${currentAmount}\nNew Amount: $${newAmount}\n\nUser balance has been recalculated.`);
      
      // Force refresh user profile
      if (selectedUser) {
        await fetchUserProfile(selectedUser, true);
      }
      setRefreshKey(k => k + 1);
    } else {
      const error = await response.json();
      alert(`❌ Error: ${error.message}`);
    }
  } catch (error) {
    console.error('❌ Error editing withdrawal:', error);
    alert('❌ Network error occurred');
  }
};

  // âœ… NEW: Edit total free margin for user
  const handleEditTotalFreeMargin = async (userId, currentFreeMargin) => {
    const newFreeMargin = prompt('Edit Total Free Margin:', currentFreeMargin);
    if (newFreeMargin === null || parseFloat(newFreeMargin) < 0) return;

    const adminNotes = prompt('Admin notes (optional):', '');

    try {
      const response = await api(`/public/edit-total-free-margin/${userId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          newFreeMargin: parseFloat(newFreeMargin),
          adminNotes: adminNotes || `Total Free Margin updated by admin on ${new Date().toLocaleString()}`
        })
      });

      if (response.ok) {
        alert('âœ… Total Free Margin updated successfully!');
        if (selectedUser) {
          await fetchUserProfile(selectedUser, true); // Force refresh
        }
        setRefreshKey(k => k + 1);
      } else {
        const error = await response.json();
        alert(`âŒ Error updating free margin: ${error.message}`);
      }
    } catch (error) {
      console.error('âŒ Error editing free margin:', error);
      alert('âŒ Network error occurred');
    }
  };

  // âœ… FIXED: Edit trading account details with refresh
  const handleEditTradingAccount = async (accountId, field, currentValue) => {
    let newValue;
    if (field === 'leverage') {
      const validLeverages = [1, 50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000];
      newValue = prompt(`Edit Leverage (valid: ${validLeverages.join(', ')}):`, currentValue);
      if (newValue === null) return;
      if (!validLeverages.includes(parseInt(newValue))) {
        alert(`❌ Invalid leverage. Must be one of: ${validLeverages.join(', ')}`);
        return;
      }
    } else {
      newValue = prompt(`Edit ${field}:`, currentValue);
      if (newValue === null || (field !== 'group' && parseFloat(newValue) < 0)) return;
    }
    try {
      const response = await api(`/public/edit-trading-account/${accountId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          field: field,
          value: field === 'group' ? newValue : parseFloat(newValue),
          adminNotes: `${field} updated by admin on ${new Date().toLocaleString()}`
        })
      });

      if (response.ok) {
        alert(`âœ… Trading account ${field} updated successfully!`);
        // âœ… FIXED: Refresh user profile to update total free margin
        if (selectedUser) {
          await fetchUserProfile(selectedUser, true); // Force refresh
        }
        setRefreshKey(k => k + 1);
      } else {
        const error = await response.json();
        alert(`âŒ Error updating ${field}: ${error.message}`);
      }
    } catch (error) {
      console.error(`âŒ Error editing trading account ${field}:`, error);
      alert('âŒ Network error occurred');
    }
  };

  // âœ… NEW: Start editing trading account inline
 const startEditingAccount = (accountId) => {
    setIsEditing(true);
    setEditingAccountId(accountId);
    const account = userProfile?.tradingAccounts?.find(acc => acc._id === accountId);
    if (account) {
      setEditValues({
        balance: account.balance || 0,
        equity: account.equity || account.balance || 0,
        freeMargin: account.freeMargin || account.equity || account.balance || 0,
        group: account.group || 'STANDARD',
        leverage: account.leverage || 100
      });
    }
  };

  // âœ… NEW: Save inline edits
  const saveAccountEdits = async (accountId) => {
    try {
     // Save leverage separately since bulk-edit route handles balance/equity/freeMargin/group
      if (editValues.leverage) {
        await api(`/public/edit-trading-account/${accountId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ field: 'leverage', value: parseInt(editValues.leverage) })
        });
      }
      const response = await api(`/public/bulk-edit-trading-account/${accountId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...editValues,
          adminNotes: `Bulk edit by admin on ${new Date().toLocaleString()}`
        })
      });

      if (response.ok) {
        alert('âœ… Trading account updated successfully!');
        setEditingAccountId(null);
        setEditValues({});
        setIsEditing(false);
        if (editingTimeout) clearTimeout(editingTimeout);
        if (selectedUser) {
          await fetchUserProfile(selectedUser, true); // Force refresh
        }
        setRefreshKey(k => k + 1);
      } else {
        const error = await response.json();
        alert(`âŒ Error updating account: ${error.message}`);
      }
    } catch (error) {
      console.error('âŒ Error saving account edits:', error);
      alert('âŒ Network error occurred');
    }
  };

  // âœ… NEW: Cancel inline edits
  const cancelAccountEdits = () => {
    setEditingAccountId(null);
    setEditValues({});
    setIsEditing(false);
    if (editingTimeout) clearTimeout(editingTimeout);
  };

  /* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ ACTIONS â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
  const simplePut = async (url, body = {}) =>
    api(url, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    });

  const handleApprove = (id) => {
    if (confirm("Approve this user?")) {
      simplePut(`/public/approve-user/${id}`)
        .then(() => {
          console.log("User approved");
          setRefreshKey(k => k + 1);
        })
        .catch(err => console.error("âŒ Error approving user:", err));
    }
  };

  const handleReject = (id) => {
    if (confirm("Reject this user?")) {
      simplePut(`/public/reject-user/${id}`)
        .then(() => {
          console.log("User rejected");
          setRefreshKey(k => k + 1);
        })
        .catch(err => console.error("âŒ Error rejecting user:", err));
    }
  };

  // âœ… UPDATED: Enhanced balance update with synchronization
  const handleUpdateBalance = async (id, current) => {
    const newBalance = prompt("New balance:", current);
    if (newBalance === null || isNaN(newBalance)) return;

    const syncChoice = confirm(
      "Balance Update Options:\n\n" +
      "OK = Update both User Balance AND distribute to Trading Accounts\n" +
      "Cancel = Update User Balance only\n\n" +
      "Choose OK to sync the balance across all trading accounts."
    );

    try {
      if (syncChoice) {
        const response = await api(`/public/sync-user-balance/${id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            newBalance: parseFloat(newBalance),
            syncMode: 'manual'
          })
        });

        if (response.ok) {
          const result = await response.json();
          alert(`âœ… Balance updated and synchronized!\n\n` +
                `User Balance: $${result.data.user.balance}\n` +
                `Total Account Balance: $${result.data.totalAccountBalance}\n` +
                `Updated ${result.data.tradingAccounts.length} trading accounts`);
        } else {
          const error = await response.json();
          alert(`âŒ Error: ${error.message}`);
        }
      } else {
        await simplePut(`/public/update-user-balance/${id}`, { 
          balance: parseFloat(newBalance),
          syncToAccounts: false
        });
        alert('âœ… User balance updated (trading accounts unchanged)');
      }
      
      setRefreshKey(k => k + 1);
    } catch (err) {
      console.error("âŒ Error updating balance:", err);
      alert('âŒ Network error occurred');
    }
  };

  // âœ… NEW: Add sync balance function
  const handleSyncBalance = async (userId, userBalance, accountBalance) => {
    const choice = confirm(
      `Balance Synchronization:\n\n` +
      `User Balance: $${userBalance}\n` +
      `Trading Accounts Total: $${accountBalance}\n\n` +
      `OK = Sync User Balance to match Trading Accounts\n` +
      `Cancel = Distribute User Balance to Trading Accounts`
    );

    try {
      const response = await api(`/public/sync-user-balance/${userId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          syncMode: choice ? 'accounts-to-user' : 'user-to-accounts'
        })
      });

      if (response.ok) {
        const result = await response.json();
        alert(`âœ… Balance synchronized!\n\n` +
              `User Balance: $${result.data.user.balance}\n` +
              `Total Account Balance: $${result.data.totalAccountBalance}`);
        setRefreshKey(k => k + 1);
      } else {
        const error = await response.json();
        alert(`âŒ Error: ${error.message}`);
      }
    } catch (error) {
      console.error('âŒ Error syncing balance:', error);
      alert('âŒ Network error occurred');
    }
  };
const handleDeleteUser = async (userId, userName) => {
  const confirmation = prompt(
    `⚠️ PERMANENTLY DELETE USER ⚠️\n\nUser: ${userName}\n\nThis will delete:\n• User account\n• All trading accounts\n• All deposits & withdrawals\n• KYC profile\n• Referrals\n\nType "DELETE" to confirm:`
  );
  if (confirmation !== "DELETE") {
    alert("❌ Deletion cancelled");
    return;
  }
  try {
    const response = await api(`/public/delete-user/${userId}`, { method: "DELETE" });
    if (response.ok) {
      alert("✅ User permanently deleted");
      setUserProfile(null);
      setSelectedUser(null);
      setRefreshKey(k => k + 1);
    } else {
      const error = await response.json();
      alert(`❌ Error: ${error.message}`);
    }
  } catch (error) {
    console.error("❌ Error deleting user:", error);
    alert("❌ Network error occurred");
  }
};
  const handleUpdateType = async (id, current) => {
    const val = prompt("New account type (standard / premium / professional / vip):", current);
    if (val) {
      try {
        await simplePut(`/public/update-user-account-type/${id}`, { accountType: val.toLowerCase() });
        console.log("Account type updated");
        setRefreshKey(k => k + 1);
      } catch (err) {
        console.error("âŒ Error updating account type:", err);
      }
    }
  };

  /* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ UI UTILS â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
  const showDate = d => d ? new Date(d).toLocaleString() : "â€”";

  const acctInfo = t => ({
    standard: { c: "#3b82f6", i: "ðŸŒŸ", l: "Standard" },
    premium: { c: "#f59e0b", i: "â­", l: "Premium" },
    professional: { c: "#8b5cf6", i: "ðŸ’¼", l: "Professional" },
    vip: { c: "#10b981", i: "ðŸ‘‘", l: "VIP" }
  }[t?.toLowerCase()] || { c: "#6b7280", i: "â“", l: t || "Unknown" });

  /* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ RENDER â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
  if (loading) return (
    <div className={styles.loadingState}>
      <h2>Loading users...</h2>
    </div>
  );

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1>ðŸ‘¥ User Management</h1>
        <button onClick={() => setRefreshKey(k => k + 1)}>ðŸ”„ Refresh</button>
      </header>

      {/* âœ… NEW: Tab Navigation */}
      <div style={{
        display: 'flex',
        gap: '10px',
        borderBottom: '2px solid #e5e7eb',
        marginBottom: '20px'
      }}>
        <TabButton
          active={activeTab === 'pending'}
          onClick={() => setActiveTab('pending')}
          count={pendingUsers.length}
        >
          â³ Pending Users
        </TabButton>

        <TabButton
          active={activeTab === 'approved'}
          onClick={() => setActiveTab('approved')}
          count={approvedUsers.length}
        >
          âœ… Approved Users
        </TabButton>

        <TabButton
          active={activeTab === 'kyc'}
          onClick={() => setActiveTab('kyc')}
          count={kycProfiles.length}
        >
          ðŸ“‹ KYC Profiles
        </TabButton>

                <TabButton
          active={activeTab === 'trade-history'}
          onClick={() => setActiveTab('trade-history')}
          count={selectedUser ? (userProfile?.tradeHistory?.length || 0) : 0}
        >
          ðŸ“Š Trade History
        </TabButton>
<TabButton 
  active={activeTab === 'trading'} 
  onClick={() => setActiveTab('trading')}
  count={liveUserAccounts.length}
>
  ðŸ”´ Live Trading Monitor
</TabButton>

      </div>

      {/* Pending Users Tab */}
      {activeTab === 'pending' && (
        <Section title="Pending Registrations" color="#f59e0b" count={pendingUsers.length}>
          {pendingUsers.length === 0
            ? <Empty msg="No pending registrations." />
            : <CardGrid
              users={pendingUsers}
              actions
              onApprove={handleApprove}
              onReject={handleReject}
              onViewProfile={fetchUserProfile}
              acctInfo={acctInfo}
              showDate={showDate}
            />
          }
        </Section>
      )}

      {/* Approved Users Tab */}
      {activeTab === 'approved' && (
        <Section title="Approved Users" color="#10b981" count={approvedUsers.length}>
          {approvedUsers.length === 0
            ? <Empty msg="No approved users yet." />
            : <Table
              users={approvedUsers}
              kycProfiles={kycProfiles}
              acctInfo={acctInfo}
              showDate={showDate}
              onBal={handleUpdateBalance}
              onType={handleUpdateType}
              onViewProfile={fetchUserProfile}
              onSyncBalance={handleSyncBalance}
onDelete={handleDeleteUser}
            />
          }
        </Section>
      )}

      {/* KYC Profiles Tab */}
      {activeTab === 'kyc' && (
        <Section title="KYC Verified Users" color="#8b5cf6" count={kycProfiles.length}>
          {kycProfiles.length === 0
            ? <Empty msg="No KYC profiles yet." />
            : <KycTable
              kycProfiles={kycProfiles}
              onViewProfile={fetchUserProfile}
              onResetPin={handleResetPin}
              newPin={newPin}
              setNewPin={setNewPin}
              showDate={showDate}
            />
          }
        </Section>
      )}

     {activeTab === 'trade-history' && (
    <Section title="Trade History Management" color="#dc2626"
      count={liveUserAccounts.reduce((s, a) => s + (a.tradeHistory?.length || 0), 0)}>
      <AllAccountsTradeHistory
        liveUserAccounts={liveUserAccounts}
        api={api}
        onRefresh={fetchLiveTradingData}
      />
    </Section>
  )}


{/* âœ… NEW: Live Trading Monitor Section */}
{activeTab === 'trading' && (
  <Section 
    title="Live Trading Monitor - Real-time Position Tracking" 
    color="#dc2626" 
    count={allOpenPositions.length}
  >
    {allOpenPositions.length === 0 ? (
      <Empty msg="No open positions across all users." />
    ) : (
      <div style={{ padding: '20px' }}>
        {/* Live Positions Table */}
        <div style={{ marginBottom: '30px' }}>
          <h4 style={{ background: '#dc2626', color: 'white', padding: '12px', borderRadius: '8px 8px 0 0', margin: '0', display: 'flex', alignItems: 'center', gap: '10px' }}>
            ðŸ”´ LIVE OPEN POSITIONS ({allOpenPositions.length})
            <span style={{ fontSize: '12px', background: 'rgba(255,255,255,0.2)', padding: '4px 8px', borderRadius: '4px' }}>
              Auto-refresh every 3s
            </span>
          </h4>
          <div style={{ overflowX: 'auto', background: '#f8fafc', borderRadius: '0 0 8px 8px', border: '1px solid #e5e7eb' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
              <thead>
               <tr style={{ background: '#f1f5f9', borderBottom: '2px solid #e2e8f0' }}>
              <th style={{ padding: '10px', textAlign: 'left' }}>User</th>
              <th style={{ padding: '10px', textAlign: 'left' }}>Account ID</th>
              <th style={{ padding: '10px', textAlign: 'center', color: '#7c3aed', fontWeight: 'bold' }}>Leverage</th>
              <th style={{ padding: '10px', textAlign: 'left' }}>Symbol</th>
              <th style={{ padding: '10px', textAlign: 'center' }}>Type</th>
              <th style={{ padding: '10px', textAlign: 'right' }}>Volume</th>
              <th style={{ padding: '10px', textAlign: 'right' }}>Open Price ✏️</th>
              <th style={{ padding: '10px', textAlign: 'right' }}>Current Price</th>
              <th style={{ padding: '10px', textAlign: 'right' }}>P&L</th>
              <th style={{ padding: '10px', textAlign: 'center' }}>Duration</th>
              <th style={{ padding: '10px', textAlign: 'center' }}>Admin Action</th>
            </tr>
              </thead>
              <tbody>
                {allOpenPositions.map(position => (
                  <tr key={position.positionId} style={{ borderBottom: '1px solid #e5e7eb' }}>
                    <td style={{ padding: '10px', fontWeight: 'bold' }}>
                      {position.userName}
                      <div style={{ fontSize: '11px', color: '#6b7280' }}>
                        {position.userEmail}
                      </div>
                    </td>
                    <td style={{ padding: '10px', fontWeight: 'bold', color: '#1e40af' }}>
                      #{position.accountId}
                    </td>
                    {/* ✅ Leverage from the account */}
                    <td style={{ padding: '10px', textAlign: 'center', fontWeight: 'bold', color: '#7c3aed' }}>
                      {(() => {
                                               const acct = liveUserAccounts.find(a => a.accountId === position.accountId);
                        const lev = acct ? (acct.leverage || 100) : 100;
                        return (
                          <span
                            style={{cursor:'pointer', color:'#7c3aed', textDecoration:'underline dotted', fontWeight:'bold'}}
                            title="Click to edit leverage — may auto-close on margin call"
                            onClick={async () => {
                              const newLev = prompt(`Edit Leverage (current: 1:${lev})\nValid: 1,50,100,200,300,500,1000...`, lev);
                              if (!newLev || isNaN(newLev)) return;
                              try {
                                const token = localStorage.getItem("userToken");
const response = await fetch(`${API_BASE_URL}/api/admin/public/edit-open-position/${position.positionId}`, {
  method: 'PUT',
  headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
  body: JSON.stringify({ leverage: parseInt(newLev) })
});
                                const data = await response.json();
                                if (data.success) {
                                  if (data.autoClose) {
                                    alert(`⚠️ Leverage 1:${newLev} caused MARGIN CALL!\nPosition auto-closed. P&L: ${data.profit?.toFixed(2)}`);
                                  } else {
                                    alert(`✅ Leverage updated to 1:${newLev}`);
                                  }
                                  fetchLiveTradingData();
                                } else { alert(`Error: ${data.message}`); }
                              } catch(e) { alert('Error: ' + e.message); }
                            }}
                          >1:{lev} ✏️</span>
                        );
                      })()}
                    </td>
                    <td style={{ padding: '10px', fontWeight: 'bold', background: '#e8f5e8', color: '#2e7d32' }}>
                      {position.symbol}
                    </td>
                    <td style={{ padding: '10px', textAlign: 'center', fontWeight: 'bold', color: position.type === 'buy' ? '#4caf50' : '#f44336' }}>
                      {position.type.toUpperCase()}
                    </td>
                    <td style={{ padding: '10px', textAlign: 'right', fontWeight: 'bold', backgroundColor: '#fff3e0', color: '#e65100' }}>
  <span
    style={{ cursor: 'pointer', textDecoration: 'underline dotted' }}
    title="Click to edit volume — recalculates margin & P&L"
    onClick={async () => {
      const newVol = prompt(`Edit Volume for ${position.symbol} (current: ${position.volume.toFixed(2)})\nMin: 0.01`, position.volume.toFixed(2));
      if (!newVol || isNaN(newVol) || parseFloat(newVol) < 0.01) return;
      try {
        const token = localStorage.getItem("userToken");
        const response = await fetch(`${API_BASE_URL}/api/admin/public/edit-open-position/${position.positionId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
          body: JSON.stringify({ volume: parseFloat(parseFloat(newVol).toFixed(2)) })
        });
        const data = await response.json();
        if (data.success) {
          if (data.autoClose) {
            alert(`⚠️ Volume change caused MARGIN CALL!\nPosition auto-closed. P&L: $${data.profit?.toFixed(2)}`);
          } else {
            alert(`✅ Volume updated to ${parseFloat(newVol).toFixed(2)}\nNew PnL: $${data.position?.unrealizedPnL?.toFixed(2)}`);
          }
          fetchLiveTradingData();
        } else {
          alert('❌ ' + data.message);
        }
      } catch (e) {
        alert('❌ Error: ' + e.message);
      }
    }}
  >
    {position.volume.toFixed(2)} ✏️
  </span>
</td>
                    <td style={{ padding: '10px', textAlign: 'right', fontFamily: 'monospace' }}>
                      <span
                        style={{ cursor: 'pointer', color: '#1565c0', textDecoration: 'underline dotted' }}
                        title="Click to edit open price (auto-recalculates P&L)"
                        onClick={async () => {
                          const newPrice = prompt(`Edit Open Price for ${position.symbol}:`, position.openPrice);
                          if (!newPrice || isNaN(newPrice)) return;
                          try {
                            const token = localStorage.getItem("userToken");
const response = await fetch(`${API_BASE_URL}/api/admin/public/edit-open-position/${position.positionId}`, {
  method: 'PUT',
  headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
  body: JSON.stringify({ openPrice: parseFloat(newPrice) })
});
                            const data = await response.json();
                            if (data.success) {
                              alert(`✅ Open price updated!\nNew PnL: $${data.position.unrealizedPnL?.toFixed(2)}`);
                              fetchLiveTradingData();
                            } else {
                              alert('❌ ' + data.message);
                            }
                          } catch (e) { alert('Error: ' + e.message); }
                        }}
                      >
                        {position.openPrice.toFixed(5)} ✏️
                      </span>
                    </td>
                    <td style={{ padding: '10px', textAlign: 'right', fontFamily: 'monospace' }}>
                      {position.currentPrice.toFixed(5)}
                    </td>
                    <td style={{ 
                      padding: '10px', 
                      textAlign: 'right', 
                      fontWeight: 'bold', 
                      fontSize: '14px', 
                      color: position.unrealizedPnL >= 0 ? '#4caf50' : '#f44336',
                      background: position.unrealizedPnL >= 0 ? '#e8f5e8' : '#ffebee'
                    }}>
                      ${position.unrealizedPnL.toFixed(2)}
                    </td>
                    <td style={{ padding: '10px', textAlign: 'center', fontSize: '11px' }}>
                      {Math.floor((Date.now() - new Date(position.openedAt).getTime()) / (1000 * 60))}m
                    </td>
                    <td style={{ padding: '10px', textAlign: 'center' }}>
                      <button 
                        onClick={async () => {
                          if (confirm(`Force close ${position.symbol} ${position.type.toUpperCase()} position for ${position.userName}?`)) {
                            try {
                              const token = localStorage.getItem("userToken");
const response = await fetch(`${API_BASE_URL}/api/admin/public/admin-close-position/${position.positionId}`, {
  method: 'DELETE',
  headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
});
                              if (response.ok) {
                                const data = await response.json();
                                alert(`✅ Position force-closed! P&L: $${data.profit?.toFixed(2) ?? '0.00'}`);
                                fetchLiveTradingData();
                              } else {
                                const err = await response.json();
                                alert(`❌ Force close failed: ${err.message}`);
                              }
                            } catch (error) {
                              alert('Error closing position');
                            }
                          }
                        }}
                        style={{ 
                          background: '#f44336', 
                          color: 'white', 
                          border: 'none', 
                          padding: '4px 8px', 
                          borderRadius: '4px', 
                          cursor: 'pointer', 
                          fontSize: '10px',
                          fontWeight: 'bold'
                        }}
                      >
                        FORCE CLOSE
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Live Account Balances */}
        <div>
          <h4 style={{ background: '#10b981', color: 'white', padding: '12px', borderRadius: '8px 8px 0 0', margin: '0' }}>
            ðŸ’° LIVE ACCOUNT BALANCES
          </h4>
          <div style={{ overflowX: 'auto', background: '#f8fafc', borderRadius: '0 0 8px 8px', border: '1px solid #e5e7eb' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
              <thead>
                <tr style={{ background: '#f1f5f9', borderBottom: '2px solid #e2e8f0' }}>
                  <th style={{ padding: '10px', textAlign: 'left' }}>User</th>
                  <th style={{ padding: '10px', textAlign: 'left' }}>Account ID</th>
                  <th style={{ padding: '10px', textAlign: 'right' }}>Balance</th>
                  <th style={{ padding: '10px', textAlign: 'right' }}>Equity</th>
                  <th style={{ padding: '10px', textAlign: 'right' }}>Free Margin</th>
                  <th style={{ padding: '10px', textAlign: 'center' }}>Open Positions</th>
                  <th style={{ padding: '10px', textAlign: 'center' }}>Quick Edit</th>
                </tr>
              </thead>
              <tbody>
                {liveUserAccounts.map(account => (
                  <tr key={account._id} style={{ borderBottom: '1px solid #e5e7eb' }}>
                    <td style={{ padding: '10px', fontWeight: 'bold' }}>
                      {account.userName}
                    </td>
                    <td style={{ padding: '10px', fontWeight: 'bold', color: '#1e40af' }}>
                      #{account.accountId}
                    </td>
                    <td style={{ padding: '10px', textAlign: 'right', fontWeight: 'bold', color: '#166534' }}>
                      ${account.balance.toFixed(2)}
                    </td>
                    <td style={{ padding: '10px', textAlign: 'right', fontWeight: 'bold', color: '#7c3aed' }}>
                      ${account.equity.toFixed(2)}
                    </td>
                    <td style={{ 
                      padding: '10px', 
                      textAlign: 'right', 
                      fontWeight: 'bold', 
                      color: '#dc2626',
                      cursor: 'pointer'
                    }}
                    onClick={async () => {
                      const newMargin = prompt('Edit Free Margin:', account.freeMargin);
                      if (newMargin && !isNaN(newMargin)) {
                        try {
                          const response = await api(`/trading-accounts/${account._id}`, {
  method: 'PUT',
  body: JSON.stringify({ freeMargin: parseFloat(newMargin) })
});
                          if (response.ok) {
                            alert('Free margin updated!');
                            fetchLiveTradingData();
                          }
                        } catch (error) {
                          alert('Error updating margin');
                        }
                      }
                    }}
                    title="Click to edit Free Margin"
                    >
                      ${account.freeMargin.toFixed(2)} âœï¸
                    </td>
                    <td style={{ padding: '10px', textAlign: 'center', fontWeight: 'bold' }}>
                      {account.openPositionsCount || 0}
                    </td>
                    <td style={{ padding: '10px', textAlign: 'center' }}>
                      <button 
                       onClick={() => {
  const uid = account.userId?._id || account.userId;
  setSelectedUser(uid);
  fetchUserProfile(uid);
}}
                        style={{ 
                          background: '#3b82f6', 
                          color: 'white', 
                          border: 'none', 
                          padding: '4px 8px', 
                          borderRadius: '4px', 
                          cursor: 'pointer', 
                          fontSize: '10px'
                        }}
                      >
                        VIEW PROFILE
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )}

            {/* âœ… ADD THIS: Complete Trade History Manager */}
        <div style={{ marginTop: '30px' }}>
          <h4 style={{ background: '#7c3aed', color: 'white', padding: '12px', borderRadius: '8px 8px 0 0', margin: '0' }}>
            ðŸ“Š ALL ACCOUNTS TRADE HISTORY - ADMIN EDITING ({liveUserAccounts.reduce((sum, acc) => sum + (acc.tradeHistory?.length || 0), 0)} trades)
          </h4>
          
          <div style={{ background: '#f8fafc', borderRadius: '0 0 8px 8px', border: '1px solid #e5e7eb', padding: '20px' }}>
            {liveUserAccounts.length > 0 ? (
              liveUserAccounts.map(account => (
                <div key={account._id} style={{ marginBottom: '30px', background: 'white', borderRadius: '8px', padding: '20px', border: '1px solid #e5e7eb' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px', background: '#f1f5f9', padding: '12px', borderRadius: '6px' }}>
                    <h5 style={{ color: '#1e40af', margin: '0', fontSize: '16px', fontWeight: 'bold' }}>
                      {account.userId?.firstName} {account.userId?.lastName} - Account: {account.accountId}
                    </h5>
                    <span style={{ background: '#10b981', color: 'white', padding: '4px 12px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold' }}>
                      {account.tradeHistory?.length || 0} Trades
                    </span>
                  </div>
                  
                  {account.tradeHistory && account.tradeHistory.length > 0 ? (
               <div style={{ overflowX: 'auto', maxHeight: '400px', overflowY: 'auto' }}>
                      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                        <thead>
                         <tr style={{ background: '#1976d2', color: 'white' }}>
                            <th style={{ padding: '10px 8px', textAlign: 'left', border: '1px solid #1565c0', fontWeight: 'bold' }}>Trade ID</th>
                            <th style={{ padding: '10px 8px', textAlign: 'left', border: '1px solid #1565c0', fontWeight: 'bold' }}>Symbol</th>
                            <th style={{ padding: '10px 8px', textAlign: 'center', border: '1px solid #1565c0', fontWeight: 'bold' }}>Type</th>
                            <th style={{ padding: '10px 8px', textAlign: 'right', border: '1px solid #1565c0', fontWeight: 'bold' }}>Volume</th>
                            <th style={{ padding: '10px 8px', textAlign: 'right', border: '1px solid #1565c0', fontWeight: 'bold' }}>Open Price</th>
                            <th style={{ padding: '10px 8px', textAlign: 'right', border: '1px solid #1565c0', fontWeight: 'bold' }}>Close Price</th>
                            <th style={{ padding: '10px 8px', textAlign: 'right', border: '1px solid #1565c0', fontWeight: 'bold' }}>Profit/Loss</th>
                            <th style={{ padding: '10px 8px', textAlign: 'right', border: '1px solid #1565c0', fontWeight: 'bold' }}>Commission</th>
                            <th style={{ padding: '10px 8px', textAlign: 'right', border: '1px solid #1565c0', fontWeight: 'bold' }}>Swap</th>
                            <th style={{ padding: '10px 8px', textAlign: 'center', border: '1px solid #1565c0', fontWeight: 'bold', minWidth: '130px' }}>Open Time ✏️</th>
                            <th style={{ padding: '10px 8px', textAlign: 'center', border: '1px solid #1565c0', fontWeight: 'bold', minWidth: '130px' }}>Close Time ✏️</th>
                            <th style={{ padding: '10px 8px', textAlign: 'center', border: '1px solid #1565c0', fontWeight: 'bold' }}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {account.tradeHistory.map((trade, index) => (

                            <tr key={trade.tradeId || index} style={{ borderBottom: '1px solid #e5e7eb', backgroundColor: index % 2 === 0 ? '#f8fafc' : 'white' }}>
                              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: 'bold', color: '#1e40af' }}>
                                {(trade.tradeId || `T-${index}`).slice(-8)}
                                {trade.adminEdited && <span style={{ fontSize: '10px', color: '#f59e0b', marginLeft: '4px' }}>âœï¸</span>}
                              </td>
                              <td style={{ padding: '8px', border: '1px solid #e5e7eb', fontWeight: 'bold', background: '#e8f5e8', color: '#2e7d32' }}>
                                {trade.symbol}
                              </td>
                              <td style={{ padding: '8px', border: '1px solid #e5e7eb', textAlign: 'center', fontWeight: 'bold', color: trade.type === 'buy' ? '#16a34a' : '#dc2626' }}>
                                {trade.type?.toUpperCase()}
                              </td>
                              <td style={{ padding: '8px', border: '1px solid #e5e7eb', textAlign: 'right', fontWeight: 'bold', backgroundColor: '#fff3e0', color: '#e65100' }}>
                                <span 
                                  style={{ cursor: 'pointer' }}
                                  onClick={async () => {
                                    const newVolume = prompt('Edit Volume:', trade.volume);
                                    if (newVolume && !isNaN(newVolume)) {
                                      try {
                                        const response = await api(`/public/edit-trade-history/${trade.tradeId || trade.id}`, {
                                          method: 'PUT',
                                          body: JSON.stringify({ volume: parseFloat(newVolume) })
                                        });
                                        if (response.ok) {
                                          alert('Volume updated!');
                                          fetchLiveTradingData(); // Refresh
                                        }
                                      } catch (error) {
                                        alert('Error updating volume');
                                      }
                                    }
                                  }}
                                  title="Click to edit"
                                >
                                  {parseFloat(trade.volume || 0).toFixed(2)} âœï¸
                                </span>
                              </td>
                              <td style={{ padding: '8px', border: '1px solid #e5e7eb', textAlign: 'right', fontFamily: 'monospace' }}>
                                <span 
                                  style={{ cursor: 'pointer', background: '#e3f2fd', padding: '2px 4px', borderRadius: '3px' }}
                                  onClick={async () => {
                                    const newPrice = prompt('Edit Open Price:', trade.openPrice);
                                    if (newPrice && !isNaN(newPrice)) {
                                      try {
                                        const response = await api(`/public/edit-trade-history/${trade.tradeId || trade.id}`, {
                                          method: 'PUT',
                                          body: JSON.stringify({ openPrice: parseFloat(newPrice) })
                                        });
                                        if (response.ok) {
                                          alert('Open price updated!');
                                          fetchLiveTradingData();
                                        }
                                      } catch (error) {
                                        alert('Error updating open price');
                                      }
                                    }
                                  }}
                                  title="Click to edit"
                                >
                                  ${parseFloat(trade.openPrice || 0).toFixed(5)} âœï¸
                                </span>
                              </td>
                              <td style={{ padding: '8px', border: '1px solid #e5e7eb', textAlign: 'right', fontFamily: 'monospace' }}>
                                <span 
                                  style={{ cursor: 'pointer', background: '#fce4ec', padding: '2px 4px', borderRadius: '3px' }}
                                  onClick={async () => {
                                    const newPrice = prompt('Edit Close Price:', trade.closePrice);
                                    if (newPrice && !isNaN(newPrice)) {
                                      try {
                                        const response = await api(`/public/edit-trade-history/${trade.tradeId || trade.id}`, {
                                          method: 'PUT',
                                          body: JSON.stringify({ closePrice: parseFloat(newPrice) })
                                        });
                                        if (response.ok) {
                                          alert('Close price updated!');
                                          fetchLiveTradingData();
                                        }
                                      } catch (error) {
                                        alert('Error updating close price');
                                      }
                                    }
                                  }}
                                  title="Click to edit"
                                >
                                  ${parseFloat(trade.closePrice || 0).toFixed(5)} âœï¸
                                </span>
                              </td>
                              <td style={{ padding: '8px', border: '1px solid #e5e7eb', textAlign: 'right', fontWeight: 'bold', fontSize: '13px' }}>
                                <span 
                                  style={{ 
                                    cursor: 'pointer', 
                                    color: trade.profit >= 0 ? '#16a34a' : '#dc2626',
                                    background: trade.profit >= 0 ? '#e8f5e8' : '#ffebee',
                                    padding: '3px 6px',
                                    borderRadius: '4px',
                                    fontWeight: 'bold'
                                  }}
                                  onClick={async () => {
                                    const newProfit = prompt('Edit Profit/Loss:', trade.profit);
                                    if (newProfit !== null && !isNaN(newProfit)) {
                                      try {
                                        const response = await api(`/public/edit-trade-history/${trade.tradeId || trade.id}`, {
                                          method: 'PUT',
                                          body: JSON.stringify({ profit: parseFloat(newProfit) })
                                        });
                                        if (response.ok) {
                                          alert('Profit updated!');
                                          fetchLiveTradingData();
                                        }
                                      } catch (error) {
                                        alert('Error updating profit');
                                      }
                                    }
                                  }}
                                  title="Click to edit"
                                >
                                  ${parseFloat(trade.profit || 0).toFixed(2)} âœï¸
                                </span>
                              </td>
                              <td style={{ padding: '8px', border: '1px solid #e5e7eb', textAlign: 'right', color: '#dc2626', fontSize: '12px' }}>
                                <span 
                                  style={{ cursor: 'pointer' }}
                                  onClick={async () => {
                                    const newCommission = prompt('Edit Commission:', Math.abs(trade.commission || 0));
                                    if (newCommission !== null && !isNaN(newCommission)) {
                                      try {
                                        const response = await api(`/public/edit-trade-history/${trade.tradeId || trade.id}`, {
                                          method: 'PUT',
                                          body: JSON.stringify({ commission: -Math.abs(parseFloat(newCommission)) })
                                        });
                                        if (response.ok) {
                                          alert('Commission updated!');
                                          fetchLiveTradingData();
                                        }
                                      } catch (error) {
                                        alert('Error updating commission');
                                      }
                                    }
                                  }}
                                  title="Click to edit"
                                >
                                  -${Math.abs(trade.commission || 0).toFixed(2)} âœï¸
                                </span>
                              </td>
                              <td style={{ padding: '8px', border: '1px solid #e5e7eb', textAlign: 'right', color: trade.swap >= 0 ? '#16a34a' : '#dc2626', fontSize: '12px' }}>
                                <span 
                                  style={{ cursor: 'pointer' }}
                                  onClick={async () => {
                                    const newSwap = prompt('Edit Swap:', trade.swap);
                                    if (newSwap !== null && !isNaN(newSwap)) {
                                      try {
                                        const response = await api(`/public/edit-trade-history/${trade.tradeId || trade.id}`, {
                                          method: 'PUT',
                                          body: JSON.stringify({ swap: parseFloat(newSwap) })
                                        });
                                        if (response.ok) {
                                          alert('Swap updated!');
                                          fetchLiveTradingData();
                                        }
                                      } catch (error) {
                                        alert('Error updating swap');
                                      }
                                    }
                                  }}
                                  title="Click to edit"
                                >
                                  ${parseFloat(trade.swap || 0).toFixed(2)} âœï¸
                                </span>
                              </td>
                              {/* Open Time - editable */}
                              <td style={{ padding: '8px', border: '1px solid #e5e7eb', textAlign: 'center', fontSize: '11px' }}>
                                <span
                                  style={{ cursor: 'pointer', color: '#1565c0' }}
                                  title="Click to edit open time"
                                  onClick={async () => {
                                    const current = trade.openTime
                                      ? new Date(trade.openTime).toISOString().slice(0, 16)
                                      : '';
                                    const newVal = prompt('Edit Open Time (YYYY-MM-DDTHH:MM):', current);
                                    if (!newVal) return;
                                    try {
                                      const r = await api(`/public/edit-trade-history/${trade.tradeId}`, {
                                        method: 'PUT',
                                        body: JSON.stringify({ openTime: new Date(newVal).toISOString() })
                                      });
                                      if (r.ok) { alert('✅ Open time updated!'); fetchLiveTradingData(); }
                                      else alert('❌ Failed');
                                    } catch (e) { alert('Error: ' + e.message); }
                                  }}
                                >
                                  {trade.openTime ? new Date(trade.openTime).toLocaleString() : '—'} ✏️
                                </span>
                              </td>

                              {/* Close Time - editable */}
                              <td style={{ padding: '8px', border: '1px solid #e5e7eb', textAlign: 'center', fontSize: '11px' }}>
                                <span
                                  style={{ cursor: 'pointer', color: '#1565c0' }}
                                  title="Click to edit close time"
                                  onClick={async () => {
                                    const current = trade.closeTime
                                      ? new Date(trade.closeTime).toISOString().slice(0, 16)
                                      : '';
                                    const newVal = prompt('Edit Close Time (YYYY-MM-DDTHH:MM):', current);
                                    if (!newVal) return;
                                    try {
                                      const r = await api(`/public/edit-trade-history/${trade.tradeId}`, {
                                        method: 'PUT',
                                        body: JSON.stringify({ closeTime: new Date(newVal).toISOString() })
                                      });
                                      if (r.ok) { alert('✅ Close time updated!'); fetchLiveTradingData(); }
                                      else alert('❌ Failed');
                                    } catch (e) { alert('Error: ' + e.message); }
                                  }}
                                >
                                  {trade.closeTime ? new Date(trade.closeTime).toLocaleString() : '—'} ✏️
                                </span>
                              </td>

                              {/* Actions - DELETE now actually works */}
                              <td style={{ padding: '8px', border: '1px solid #e5e7eb', textAlign: 'center' }}>
                                <button
                                  onClick={async () => {
                                    if (!confirm(`Delete trade ${trade.symbol} for ${account.userId?.firstName}?\nThis cannot be undone.`)) return;
                                    try {
                                      const r = await api(`/public/delete-trade/${trade.tradeId}`, {
                                        method: 'DELETE'
                                      });
                                      const data = await r.json();
                                      if (data.success) {
                                        alert('✅ Trade deleted successfully');
                                        fetchLiveTradingData();
                                      } else {
                                        alert('❌ ' + data.message);
                                      }
                                    } catch (e) { alert('Error: ' + e.message); }
                                  }}
                                  style={{
                                    background: '#ef4444',
                                    color: 'white',
                                    border: 'none',
                                    padding: '2px 6px',
                                    borderRadius: '3px',
                                    fontSize: '10px',
                                    cursor: 'pointer'
                                  }}
                                >
                                  DELETE
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      
                      <div style={{ textAlign: 'center', marginTop: '10px', padding: '10px', background: '#f1f5f9', borderRadius: '4px' }}>
  <p style={{ color: '#6b7280', margin: 0, fontSize: '12px' }}>
    Showing all {account.tradeHistory.length} trades - Scroll to view more
  </p>
</div>

                    </div>
                  ) : (
                    <div style={{ padding: '20px', textAlign: 'center', color: '#6b7280', background: '#f9fafb', borderRadius: '6px' }}>
                      <p style={{ margin: 0 }}>No trade history for this account</p>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div style={{ padding: '20px', textAlign: 'center', color: '#6b7280' }}>
                No trading accounts found
              </div>
            )}
          </div>
        </div>

  </Section>
)}

      {/* âœ… Enhanced User Profile Modal with Trading Account Editing AND Referral Management */}
      {userProfile && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: 'white',
            padding: '30px',
            borderRadius: '12px',
            maxWidth: '1400px',
            width: '95%',
            maxHeight: '90vh',
            overflowY: 'auto'
          }}>
            {/* âœ… NEW: Enhanced header with editing status and manual refresh */}
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '20px'
            }}>
              <h2>Complete User Profile - Admin Control Panel</h2>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                {isEditing && (
                  <span style={{
                    background: '#fbbf24',
                    color: '#92400e',
                    padding: '4px 8px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    fontWeight: 'bold'
                  }}>
                    â¸ï¸ Auto-refresh paused
                  </span>
                )}
                <button
                  onClick={() => {
                    setIsEditing(false);
                    if (editingTimeout) clearTimeout(editingTimeout);
                    fetchUserProfile(selectedUser, true); // Force refresh
                  }}
                  style={{
                    background: '#10b981',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    padding: '6px 12px',
                    cursor: 'pointer',
                    fontSize: '12px'
                  }}
                >
                  ðŸ”„ Refresh Now
                </button>
                <button
                  onClick={() => {
                    setSelectedUser(null);
                    setUserProfile(null);
                    setNewPin('');
                    setEditingAccountId(null);
                    setEditValues({});
                    setIsEditing(false);
                    if (editingTimeout) clearTimeout(editingTimeout);
                  }}
                  style={{
                    background: '#ef4444',
                    color: 'white',
                    border: 'none',
                    borderRadius: '50%',
                    width: '30px',
                    height: '30px',
                    cursor: 'pointer'
                  }}
                >
                  âœ•
                </button>
              </div>
            </div>

            {/* âœ… UPDATED: User Stats with User Level Management */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: '15px',
              marginBottom: '25px'
            }}>
              <StatCard
                title="Total Balance"
                value={`$${userProfile.stats?.totalBalance?.toLocaleString() || 0}`}
                color="#0369a1"
                bgColor="#f0f9ff"
              />
              <StatCard
                title="Total Deposits"
                value={`$${userProfile.stats?.totalDeposits?.toLocaleString() || 0}`}
                color="#166534"
                bgColor="#f0fdf4"
                editable
                onClick={() => alert('Edit individual deposits in the transactions section below')}
              />
              <StatCard
                title="Total Withdrawals"
                value={`$${userProfile.stats?.totalWithdrawals?.toLocaleString() || 0}`}
                color="#991b1b"
                bgColor="#fef2f2"
                editable
                onClick={() => alert('Edit individual withdrawals in the transactions section below')}
              />
              <StatCard
                title="Total Free Margin"
                value={`$${userProfile.stats?.totalFreeMargin?.toLocaleString() || 0}`}
                color="#7c2d12"
                bgColor="#fff7ed"
                editable
                onClick={() => handleEditTotalFreeMargin(selectedUser, userProfile.stats?.totalFreeMargin || 0)}
              />
              <StatCard
                title="Trading Accounts"
                value={`${userProfile.stats?.approvedAccounts || 0} Active`}
                color="#7c2d12"
                bgColor="#fdf4ff"
              />
              {/* âœ… NEW: User Level Management */}
              <StatCard
                title="User Level"
                value={`Level ${userProfile.user?.userLevel || 1}`}

                color="#7c3aed"
                bgColor="#f3e8ff"
                editable
                onClick={async () => {
                  const newLevel = prompt(`Edit User Level (1-50):`, userProfile.user?.userLevel || 1);
if (newLevel && parseInt(newLevel) >= 1 && parseInt(newLevel) <= 50) {

                    try {
                      const response = await api(`/public/update-user-level/${selectedUser}`, {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ 
                          newLevel: parseInt(newLevel),
                          adminNotes: `Level updated by admin on ${new Date().toLocaleString()}`
                        })
                      });
                      if (response.ok) {
                        alert(`âœ… User level updated to Level ${newLevel}!`);
                        await fetchUserProfile(selectedUser, true); // Force refresh
                      } else {
                        const error = await response.json();
                        alert(`âŒ Error: ${error.message}`);
                      }
                    } catch (error) {
                      alert('âŒ Network error occurred');
                    }
                  } else {
                    alert('âŒ Please enter a valid level between 1 and 50');
                  }
                }}
              />
            </div>

            {/* KYC Profile */}
            {userProfile.kycProfile && (
              <div style={{ marginBottom: '25px' }}>
                <h3 style={{
                  background: '#10b981',
                  color: 'white',
                  padding: '10px',
                  borderRadius: '8px 8px 0 0',
                  margin: '0'
                }}>
                  âœ… KYC Profile Information
                </h3>
                <div style={{
                  background: '#f8fafc',
                  padding: '20px',
                  borderRadius: '0 0 8px 8px',
                  border: '1px solid #e5e7eb'
                }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '20px' }}>
                    <div>
                      <p><strong>Full Name:</strong> {userProfile.kycProfile.fullName}</p>
                      <p><strong>WhatsApp:</strong> {userProfile.kycProfile.whatsappNumber}</p>
                      <p><strong>Gender:</strong> {userProfile.kycProfile.gender}</p>
                    </div>
                    <div>
                      <p><strong>Trading Experience:</strong> {userProfile.kycProfile.tradingExperience}</p>
                      <p><strong>KYC Approved:</strong> {new Date(userProfile.kycProfile.firstApprovedAt).toLocaleDateString()}</p>
                    </div>
                    <div>
                      <p><strong>Current PIN:</strong>
                        <span style={{
                          background: '#fee2e2',
                          color: '#991b1b',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          fontFamily: 'monospace',
                          fontWeight: 'bold',
                          marginLeft: '8px'
                        }}>
                          {userProfile.kycProfile.withdrawalPin}
                        </span>
                      </p>
                      <div style={{ marginTop: '10px' }}>
                        <h4>ðŸ”„ Reset PIN</h4>
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                          <input
                            type="text"
                            placeholder="New PIN"
                            value={newPin}
                            onChange={(e) => setNewPin(e.target.value)}
                            style={{
                              padding: '6px',
                              border: '1px solid #d1d5db',
                              borderRadius: '4px',
                              width: '80px'
                            }}
                          />
                          <button
                            onClick={() => handleResetPin(selectedUser)}
                            style={{
                              background: '#f59e0b',
                              color: 'white',
                              border: 'none',
                              padding: '6px 12px',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '12px'
                            }}
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                      {/* ✅ NEW: Reset Account Password */}
<div style={{ marginTop: '15px' }}>
  <h4 style={{ margin: '0 0 8px 0', color: '#dc2626' }}>🔑 Reset Login Password</h4>
  <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
    <input
      type="password"
      placeholder="New Password (min 6 chars)"
      value={newPassword}
      onChange={(e) => setNewPassword(e.target.value)}
      style={{
        padding: '6px',
        border: '1px solid #d1d5db',
        borderRadius: '4px',
        fontSize: '13px',
        width: '180px'
      }}
    />
    <input
      type="password"
      placeholder="Confirm Password"
      value={confirmNewPassword}
      onChange={(e) => setConfirmNewPassword(e.target.value)}
      style={{
        padding: '6px',
        border: `1px solid ${confirmNewPassword && newPassword !== confirmNewPassword ? '#ef4444' : '#d1d5db'}`,
        borderRadius: '4px',
        fontSize: '13px',
        width: '180px'
      }}
    />
    <button
      onClick={() => handleResetPassword(selectedUser)}
      style={{
        background: '#dc2626',
        color: 'white',
        border: 'none',
        padding: '6px 12px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '12px',
        width: '180px'
      }}
    >
      🔑 Reset Password
    </button>
  </div>
</div>
                    </div>
                  </div>

                  {/* KYC Documents */}
                  {(userProfile.kycProfile.storedIdentityProof || userProfile.kycProfile.storedProofOfResidence) && (
                    <div style={{ marginTop: '20px' }}>
                      <h4>ðŸ“ KYC Documents</h4>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                        {userProfile.kycProfile?.storedIdentityProof && (
                          <DocumentCard
  title="Identity Proof"
  fileName={userProfile.kycProfile.storedIdentityProof.originalName}
  fileUrl={userProfile.kycProfile.storedIdentityProof.url || `${API_BASE_URL}/uploads/transactions/${userProfile.kycProfile.storedIdentityProof.filename}`}
  bgColor="#e0f2fe"
  buttonColor="#0369a1"
                          />
                        )}

                        {userProfile.kycProfile?.storedProofOfResidence && (
                          <DocumentCard
  title="Proof of Residence" 
  fileName={userProfile.kycProfile.storedProofOfResidence.originalName}
  fileUrl={userProfile.kycProfile.storedProofOfResidence.url || `${API_BASE_URL}/uploads/transactions/${userProfile.kycProfile.storedProofOfResidence.filename}`}
  bgColor="#ecfdf5"
  buttonColor="#166534"
                          />
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* âœ… Enhanced Transactions Section with Edit Functionality */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
              {/* Deposits */}
              <div>
                <h4>ðŸ’° Deposits ({userProfile.deposits?.length || 0}) - 
                  <span style={{ color: '#166534', fontWeight: 'bold' }}>
                    Total: ${userProfile.stats?.totalDeposits?.toLocaleString() || 0}
                  </span>
                </h4>
                <div style={{ maxHeight: '300px', overflowY: 'auto', background: '#f8fafc', borderRadius: '6px', padding: '10px' }}>
                  {userProfile.deposits?.map((deposit) => (
                    <div key={deposit._id} style={{
                      padding: '12px',
                      borderBottom: '1px solid #e5e7eb',
                      fontSize: '14px'
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                          <span>{new Date(deposit.createdAt).toLocaleDateString()}</span>
                          <div style={{ fontSize: '12px', color: '#6b7280' }}>
                            {deposit.gateway} â€¢ {deposit.status}
                          </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <span style={{ fontWeight: 'bold', fontSize: '16px' }}>${deposit.amount}</span>
                          <button
                            onClick={() => handleEditTransaction('deposit', deposit._id, deposit.amount)}
                            style={{
                              background: '#3b82f6',
                              color: 'white',
                              border: 'none',
                              padding: '4px 8px',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '10px'
                            }}
                          >
                            âœï¸ Edit
                          </button>
                        </div>
                      </div>
                    </div>
                  )) || <p style={{ color: '#6b7280', fontStyle: 'italic' }}>No deposits found</p>}
                </div>
              </div>

              {/* Withdrawals */}
              <div>
                <h4>ðŸ’¸ Withdrawals ({userProfile.withdrawals?.length || 0}) - 
                  <span style={{ color: '#991b1b', fontWeight: 'bold' }}>
                    Total: ${userProfile.stats?.totalWithdrawals?.toLocaleString() || 0}
                  </span>
                </h4>
                <div style={{ maxHeight: '300px', overflowY: 'auto', background: '#f8fafc', borderRadius: '6px', padding: '10px' }}>
                  {userProfile.withdrawals?.map((withdrawal) => (
                    <div key={withdrawal._id} style={{
                      padding: '12px',
                      borderBottom: '1px solid #e5e7eb',
                      fontSize: '14px'
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                          <span>{new Date(withdrawal.createdAt).toLocaleDateString()}</span>
                          <div style={{ fontSize: '12px', color: '#6b7280' }}>
                            {withdrawal.withdrawalType || 'KYC'} â€¢ {withdrawal.status}
                          </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <span style={{ fontWeight: 'bold', fontSize: '16px' }}>${withdrawal.amount}</span>
                          <button
                            // ✅ CORRECT
onClick={() => handleEditWithdrawal(withdrawal._id, withdrawal.amount, withdrawal.status)}

                            style={{
                              background: '#ef4444',
                              color: 'white',
                              border: 'none',
                              padding: '4px 8px',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '10px'
                            }}
                          >
                            âœï¸ Edit
                          </button>
                        </div>
                      </div>
                    </div>
                  )) || <p style={{ color: '#6b7280', fontStyle: 'italic' }}>No withdrawals found</p>}
                </div>
              </div>
            </div>

            {/* âœ… TRADING ACCOUNTS SECTION */}
            <div style={{ marginBottom: '20px' }}>
              <h4 style={{
                background: '#dc2626',
                color: 'white',
                padding: '12px',
                borderRadius: '8px 8px 0 0',
                margin: '0',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                ðŸ› ï¸ Admin Trading Account Control Panel ({userProfile.tradingAccounts?.length || 0})
                <span style={{ fontSize: '12px', background: 'rgba(255,255,255,0.2)', padding: '4px 8px', borderRadius: '4px' }}>
                  Full Edit Access
                </span>
              </h4>
              <div style={{ background: '#f8fafc', borderRadius: '0 0 8px 8px', padding: '15px', border: '1px solid #e5e7eb' }}>
                
                {userProfile.tradingAccounts?.length === 0 ? (
                  <p style={{ color: '#6b7280', fontStyle: 'italic', textAlign: 'center', padding: '20px' }}>
                    No trading accounts found for this user
                  </p>
                ) : (
                  <div style={{ overflowX: 'auto' }}>
                    <table style={{
                      width: '100%',
                      borderCollapse: 'collapse',
                      fontSize: '14px'
                    }}>
                      <thead>
                        <tr style={{ background: '#f1f5f9', borderBottom: '2px solid #e2e8f0' }}>
                          <th style={{ padding: '10px', textAlign: 'left' }}>Account ID</th>
                          <th style={{ padding: '10px', textAlign: 'left' }}>Group</th>
                          <th style={{ padding: '10px', textAlign: 'right' }}>Balance</th>
                          <th style={{ padding: '10px', textAlign: 'right' }}>Equity</th>
                          <th style={{ padding: '10px', textAlign: 'right' }}>Free Margin</th>
                          <th style={{ padding: '10px', textAlign: 'center' }}>Leverage</th>
                          <th style={{ padding: '10px', textAlign: 'center' }}>Status</th>
                          <th style={{ padding: '10px', textAlign: 'center' }}>Admin Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {userProfile.tradingAccounts.map((account) => (
                          <tr key={account._id} style={{ borderBottom: '1px solid #e5e7eb' }}>
                            <td style={{ padding: '12px', fontWeight: 'bold', color: '#1e40af' }}>
                              {account.accountId}
                            </td>
                            

                            <td style={{ padding: '12px' }}>
                              {editingAccountId === account._id ? (
                                <select
                                  value={editValues.group || account.group}
                                  onFocus={() => handleEditingState()}
                                  onChange={(e) => {
                                    handleEditingState();
                                    setEditValues({...editValues, group: e.target.value});
                                  }}
                                  style={{
                                    padding: '4px',
                                    border: '1px solid #d1d5db',
                                    borderRadius: '4px',
                                    fontSize: '12px',
                                    background: '#fff3cd',
                                    width: '100px'
                                  }}
                                >
                                 <optgroup label="── Standard ──">
  <option value="CENT">CENT</option>
  <option value="STANDARD">STANDARD</option>
  <option value="SILVER">SILVER</option>
  <option value="PLATINUM">PLATINUM</option>
  <option value="PRO">PRO</option>
  <option value="PREMIUM">PREMIUM</option>
  <option value="VIP">VIP</option>
  <option value="GOLD">GOLD</option>
  <option value="GOLDP">GOLDP</option>
</optgroup>
<optgroup label="── Premium Gold ──">
  <option value="PREMIUM_GOLD">PREMIUM GOLD</option>
  <option value="PRIME_GOLD">PRIME GOLD</option>
  <option value="ELITE_GOLD">ELITE GOLD</option>
  <option value="ROYAL_GOLD">ROYAL GOLD</option>
  <option value="APEX_GOLD">APEX GOLD</option>
  <option value="NOBLE_GOLD">NOBLE GOLD</option>
  <option value="PURE_GOLD">PURE GOLD</option>
  <option value="SOLID_GOLD">SOLID GOLD</option>
  <option value="TRUE_GOLD">TRUE GOLD</option>
  <option value="ULTRA_GOLD">ULTRA GOLD</option>
</optgroup>
<optgroup label="── Golden Series ──">
  <option value="GOLDEN_PRIME">GOLDEN PRIME</option>
  <option value="GOLDEN_ELITE">GOLDEN ELITE</option>
  <option value="GOLDEN_APEX">GOLDEN APEX</option>
  <option value="GOLDEN_EDGE">GOLDEN EDGE</option>
  <option value="GOLDEN_VAULT">GOLDEN VAULT</option>
  <option value="PLATINUM_GOLD">PLATINUM GOLD</option>
  <option value="DIAMOND_GOLD">DIAMOND GOLD</option>
  <option value="CROWN_GOLD">CROWN GOLD</option>
  <option value="STERLING_GOLD">STERLING GOLD</option>
  <option value="LUXE_GOLD">LUXE GOLD</option>
</optgroup>
<optgroup label="── Algo Trading ──">
  <option value="ALGO_PREMIUM">ALGO PREMIUM</option>
  <option value="ALGO_GOLD">ALGO GOLD</option>
  <option value="ALGO_PRO">ALGO PRO</option>
  <option value="ALGO_VIP">ALGO VIP</option>
</optgroup>
                                </select>
                              ) : (
                                <span style={{
                                  background: account.group?.includes('ALGO') ? '#ecfdf5' : '#f0f9ff',
                                  color: account.group?.includes('ALGO') ? '#166534' : '#1e40af',
                                  padding: '4px 8px',
                                  borderRadius: '4px',
                                  fontSize: '12px',
                                  fontWeight: 'bold'
                                }}>
                                  {account.group}
                                  {account.group?.includes('ALGO') && ' ðŸ¤–'}
                                </span>
                              )}
                            </td>
                            
                            {/* Balance */}
                            <td style={{ padding: '12px', textAlign: 'right', fontWeight: 'bold' }}>
                              {editingAccountId === account._id ? (
                                <input
                                  type="number"
                                  value={editValues.balance}
                                  onFocus={() => handleEditingState()}
                                  onChange={(e) => {
                                    handleEditingState();
                                    setEditValues({...editValues, balance: parseFloat(e.target.value)});
                                  }}
                                  style={{
                                    padding: '4px',
                                    border: '2px solid #3b82f6',
                                    borderRadius: '4px',
                                    width: '80px',
                                    textAlign: 'right',
                                    background: '#eff6ff',
                                    fontWeight: 'bold'
                                  }}
                                  step="0.01"
                                />
                              ) : (
                                <span style={{ color: '#166534' }}>
                                  ${parseFloat(account.balance || 0).toLocaleString()}
                                </span>
                              )}
                            </td>
                            
                            {/* Equity */}
                            <td style={{ padding: '12px', textAlign: 'right', fontWeight: 'bold' }}>
                              {editingAccountId === account._id ? (
                                <input
                                  type="number"
                                  value={editValues.equity}
                                  onFocus={() => handleEditingState()}
                                  onChange={(e) => {
                                    handleEditingState();
                                    setEditValues({...editValues, equity: parseFloat(e.target.value)});
                                  }}
                                  style={{
                                    padding: '4px',
                                    border: '2px solid #7c3aed',
                                    borderRadius: '4px',
                                    width: '80px',
                                    textAlign: 'right',
                                    background: '#f3e8ff',
                                    fontWeight: 'bold'
                                  }}
                                  step="0.01"
                                />
                              ) : (
                                <span style={{ color: '#7c3aed' }}>
                                  ${parseFloat(account.equity || account.balance || 0).toLocaleString()}
                                </span>
                              )}
                            </td>
                            
                            {/* FREE MARGIN - ADMIN EDITABLE */}
                            <td style={{ padding: '12px', textAlign: 'right', fontWeight: 'bold' }}>
                              {editingAccountId === account._id ? (
                                <input
                                  type="number"
                                  value={editValues.freeMargin}
                                  onFocus={() => handleEditingState()}
                                  onChange={(e) => {
                                    handleEditingState();
                                    setEditValues({...editValues, freeMargin: parseFloat(e.target.value)});
                                  }}
                                  style={{
                                    padding: '4px',
                                    border: '2px solid #dc2626',
                                    borderRadius: '4px',
                                    width: '80px',
                                    textAlign: 'right',
                                    background: '#fef2f2',
                                    fontWeight: 'bold'
                                  }}
                                  step="0.01"
                                />
                              ) : (
                                <span style={{ color: '#dc2626', cursor: 'pointer' }}
                                      onClick={() => handleEditTradingAccount(account._id, 'freeMargin', account.freeMargin || account.equity || account.balance || 0)}
                                      title="Click to edit Free Margin">
                                  ${parseFloat(account.freeMargin || account.equity || account.balance || 0).toLocaleString()}
                                  <span style={{ fontSize: '10px', marginLeft: '4px' }}>âœï¸</span>
                                </span>
                              )}
                            </td>
                            
                           <td style={{ padding: '12px', textAlign: 'center', fontSize: '12px' }}>
                              {editingAccountId === account._id ? (
                                <select
                                  value={editValues.leverage ?? account.leverage ?? 100}
                                  onFocus={() => handleEditingState()}
                                  onChange={(e) => { handleEditingState(); setEditValues({...editValues, leverage: parseInt(e.target.value)}); }}
                                  style={{ padding: '3px', border: '2px solid #7c3aed', borderRadius: '3px', fontSize: '12px' }}
                                >
                                  {[1,50,100,200,300,400,500,1000,2000,3000,4000,5000,10000].map(l => (
                                    <option key={l} value={l}>1:{l}</option>
                                  ))}
                                </select>
                              ) : (
                                <span style={{ cursor: 'pointer', color: '#7c3aed', fontWeight: 'bold' }}
                                  onClick={() => handleEditTradingAccount(account._id, 'leverage', account.leverage || 100)}
                                  title="Click to edit leverage">
                                  1:{account.leverage || 100} ✏️
                                </span>
                              )}
                            </td>
                            <td style={{ padding: '12px', textAlign: 'center' }}>
                              <span style={{
                                background: account.adminStatus === 'approved' ? '#10b981' : '#f59e0b',
                                color: 'white',
                                padding: '4px 8px',
                                borderRadius: '4px',
                                fontSize: '11px',
                                fontWeight: 'bold'
                              }}>
                                {account.adminStatus}
                              </span>
                            </td>
                            <td style={{ padding: '12px', textAlign: 'center' }}>
                              {editingAccountId === account._id ? (
                                <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
                                  <button
                                    onClick={() => saveAccountEdits(account._id)}
                                    style={{
                                      background: '#10b981',
                                      color: 'white',
                                      border: 'none',
                                      padding: '6px 10px',
                                      borderRadius: '4px',
                                      cursor: 'pointer',
                                      fontSize: '11px',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    âœ… Save
                                  </button>
                                  <button
                                    onClick={cancelAccountEdits}
                                    style={{
                                      background: '#6b7280',
                                      color: 'white',
                                      border: 'none',
                                      padding: '6px 10px',
                                      borderRadius: '4px',
                                      cursor: 'pointer',
                                      fontSize: '11px'
                                    }}
                                  >
                                    âŒ Cancel
                                  </button>
                                </div>
                              ) : (
                                <button
                                  onClick={() => startEditingAccount(account._id)}
                                  style={{
                                    background: '#3b82f6',
                                    color: 'white',
                                    border: 'none',
                                    padding: '6px 12px',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '11px',
                                    fontWeight: 'bold'
                                  }}
                                >
                                  ðŸ› ï¸ Edit All
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                {/* Quick Actions */}
                <div style={{
                  marginTop: '15px',
                  padding: '15px',
                  background: '#fff7ed',
                  borderRadius: '6px',
                  border: '1px solid #fed7aa'
                }}>
                  <h5 style={{ margin: '0 0 10px 0', color: '#9a3412' }}>âš¡ Quick Admin Actions:</h5>
                  <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    <button
                      onClick={() => {
                        const newFreeMargin = prompt("Set Free Margin for ALL approved accounts:", "1000");
                        if (newFreeMargin) {
                          userProfile.tradingAccounts
                            .filter(acc => acc.adminStatus === 'approved')
                            .forEach(acc => {
                              handleEditTradingAccount(acc._id, 'freeMargin', parseFloat(newFreeMargin));
                            });
                        }
                      }}
                      style={{
                        background: '#ea580c',
                        color: 'white',
                        border: 'none',
                        padding: '8px 12px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '12px'
                      }}
                    >
                      ðŸŽ¯ Set All Free Margins
                    </button>
                    <button
  onClick={async () => {
    const approved = userProfile?.tradingAccounts?.filter(a => a.adminStatus === 'approved');
    if (!approved?.length) return alert('❌ No approved accounts found');

    // Build account selection string
    const accountList = approved.map((a, i) => `${i + 1}. Account #${a.accountId} (Credit: $${a.credit || 0})`).join('\n');
    const pick = approved.length === 1
      ? approved[0]
      : (() => {
          const idx = parseInt(prompt(`Select account to set credit:\n\n${accountList}\n\nEnter number (1-${approved.length}):`)) - 1;
          return (idx >= 0 && idx < approved.length) ? approved[idx] : null;
        })();

    if (!pick) return alert('❌ No account selected');

    const creditAmount = prompt(`Set Credit for account #${pick.accountId}:\n(Enter 0 to remove credit)`, pick.credit || 0);
    if (creditAmount === null || isNaN(creditAmount)) return;

    try {
      // ✅ Use public route (no auth required) instead of protected /set-credit/
      const response = await api(`/public/edit-trading-account/${pick._id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          field: 'credit',
          value: parseFloat(creditAmount) || 0,
          adminNotes: `Credit set to $${creditAmount} by admin on ${new Date().toLocaleString()}`
        })
      });
      const data = await response.json();
      if (data.success) {
        alert(`✅ Credit ${parseFloat(creditAmount) === 0 ? 'removed' : `set to $${creditAmount}`} for account #${pick.accountId}`);
        await fetchUserProfile(selectedUser, true);
      } else alert('❌ ' + data.message);
    } catch (e) { alert('Error: ' + e.message); }
  }}
  style={{ background: '#9c27b0', color: 'white', border: 'none',
    padding: '8px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}
>
  💳 Set Credit
</button>
{/* ✅ ALERTS MANAGEMENT PANEL - per trading account */}
{userProfile.tradingAccounts?.map((account) => (
  <div key={`alert-panel-${account._id}`} style={{ marginBottom: '20px' }}>
    <h4 style={{
      background: '#7c3aed', color: 'white',
      padding: '12px', borderRadius: '8px 8px 0 0', margin: '0',
      display: 'flex', alignItems: 'center', gap: '10px'
    }}>
      🔔 Alerts — Account #{account.accountId} ({account.adminAlerts?.length || 0})
    </h4>
    <div style={{ background: '#f5f3ff', borderRadius: '0 0 8px 8px', padding: '15px', border: '1px solid #e5e7eb' }}>

      {/* Send New Alert */}
      <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
        <input
          id={`alert-input-${account.accountId}`}
          type="text"
          placeholder="Type alert message..."
          style={{ flex: 1, padding: '8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '13px' }}
        />
        <button
          onClick={async () => {
            const input = document.getElementById(`alert-input-${account.accountId}`);
            const message = input?.value?.trim();
            if (!message) return alert('❌ Enter a message');
            try {
              const res = await api(`/send-alert/${account.accountId}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ message })
              });
              const data = await res.json();
              if (data.success) {
                alert('✅ Alert sent!');
                input.value = '';
                await fetchUserProfile(selectedUser, true);
              } else alert(`❌ ${data.message}`);
            } catch (e) { alert('❌ Network error'); }
          }}
          style={{ background: '#7c3aed', color: 'white', border: 'none', padding: '8px 14px', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', whiteSpace: 'nowrap' }}
        >
          ➕ Send
        </button>
      </div>

      {/* Past Alerts List */}
      {(!account.adminAlerts || account.adminAlerts.length === 0) ? (
        <p style={{ color: '#6b7280', fontStyle: 'italic', fontSize: '13px' }}>No alerts sent yet.</p>
      ) : (
        <div style={{ maxHeight: '220px', overflowY: 'auto' }}>
          {[...account.adminAlerts].reverse().map((alertItem) => (
            <div key={alertItem.alertId} style={{
              background: alertItem.isRead ? '#fff' : '#ede9fe',
              border: '1px solid #ddd6fe', borderRadius: '6px',
              padding: '8px 10px', marginBottom: '6px',
              display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px'
            }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '12px', color: '#555', marginBottom: '2px' }}>
                  {new Date(alertItem.createdAt).toLocaleString()}
                  {alertItem.editedAt && <span style={{ marginLeft: '6px', color: '#9ca3af', fontSize: '11px' }}>(edited)</span>}
                  {!alertItem.isRead && <span style={{ marginLeft: '6px', background: '#7c3aed', color: 'white', fontSize: '10px', padding: '1px 5px', borderRadius: '10px' }}>NEW</span>}
                </div>
                <div style={{ fontSize: '13px', color: '#1f2937', wordBreak: 'break-word' }}>{alertItem.message}</div>
              </div>
              <div style={{ display: 'flex', gap: '4px', flexShrink: 0 }}>
                <button
                  onClick={async () => {
                    const newMsg = prompt('Edit alert:', alertItem.message);
                    if (!newMsg?.trim()) return;
                    try {
                      const res = await api(`/edit-alert/${account.accountId}/${alertItem.alertId}`, {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ message: newMsg.trim() })
                      });
                      const data = await res.json();
                      if (data.success) { alert('✅ Updated'); await fetchUserProfile(selectedUser, true); }
                      else alert(`❌ ${data.message}`);
                    } catch (e) { alert('❌ Network error'); }
                  }}
                  style={{ background: '#f59e0b', color: 'white', border: 'none', padding: '4px 8px', borderRadius: '4px', cursor: 'pointer', fontSize: '11px' }}
                >✏️ Edit</button>
                <button
                  onClick={async () => {
                    if (!confirm('Delete this alert?')) return;
                    try {
                      const res = await api(`/delete-alert/${account.accountId}/${alertItem.alertId}`, {
                        method: 'DELETE'
                      });
                      const data = await res.json();
                      if (data.success) await fetchUserProfile(selectedUser, true);
                      else alert(`❌ ${data.message}`);
                    } catch (e) { alert('❌ Network error'); }
                  }}
                  style={{ background: '#ef4444', color: 'white', border: 'none', padding: '4px 8px', borderRadius: '4px', cursor: 'pointer', fontSize: '11px' }}
                >🗑️ Del</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
))}
                  </div>
                </div>
              </div>
            </div>

            {/* âœ… FIXED: REFERRAL MANAGEMENT SECTION - No Individual Levels */}
            <div style={{ marginBottom: '20px' }}>
              <h4 style={{
                background: '#7c3aed',
                color: 'white',
                padding: '12px',
                borderRadius: '8px 8px 0 0',
                margin: '0',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                ðŸ‘¥ Referral Management System ({userProfile?.referralData?.referrals?.length || 0})
                <span style={{ fontSize: '12px', background: 'rgba(255,255,255,0.2)', padding: '4px 8px', borderRadius: '4px' }}>
                  Admin Control
                </span>
              </h4>
              
              <div style={{ background: '#f8fafc', borderRadius: '0 0 8px 8px', padding: '20px', border: '1px solid #e5e7eb' }}>
                
                {/* Referral Stats */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                  gap: '15px',
                  marginBottom: '20px'
                }}>
                  <div style={{ background: '#dbeafe', padding: '15px', borderRadius: '8px', textAlign: 'center' }}>
                    <h5 style={{ margin: '0 0 5px 0', color: '#1e40af' }}>Total Referrals</h5>
                    <p style={{ fontSize: '24px', fontWeight: 'bold', margin: 0, color: '#1e40af' }}>
                      {userProfile?.referralData?.referrals?.length || 0}
                    </p>
                  </div>
                  <div style={{ background: '#d1fae5', padding: '15px', borderRadius: '8px', textAlign: 'center' }}>
                    <h5 style={{ margin: '0 0 5px 0', color: '#065f46' }}>Total Commission</h5>
                    <p style={{ fontSize: '24px', fontWeight: 'bold', margin: 0, color: '#065f46' }}>
                      ${userProfile?.referralData?.commission?.toLocaleString() || 0}
                    </p>
                  </div>
                  <div style={{ background: '#fef3c7', padding: '15px', borderRadius: '8px', textAlign: 'center' }}>
                    <h5 style={{ margin: '0 0 5px 0', color: '#92400e' }}>User Level</h5>
                    <p style={{ fontSize: '24px', fontWeight: 'bold', margin: 0, color: '#92400e' }}>
                      Level {userProfile?.user?.userLevel || 1}

                    </p>
                    <small style={{ color: '#92400e', fontSize: '11px' }}>
                      (Admin controlled, range 1-50)

                    </small>
                  </div>
                </div>

                {/* âœ… UPDATED: Add New Referral Form - without level */}
                <div style={{ 
                  background: '#fff', 
                  padding: '20px', 
                  borderRadius: '8px', 
                  border: '2px solid #e5e7eb',
                  marginBottom: '20px'
                }}>
                  <h5 style={{ margin: '0 0 15px 0' }}>âž• Add New Referral Client</h5>
                  <form onSubmit={async (e) => {
                    e.preventDefault();
                    
                    if (!selectedUser) {
                      alert('âŒ No user selected');
                      return;
                    }
                    
                    const formData = new FormData(e.target);
                    const referralData = {
                      userId: selectedUser,
                      clientName: formData.get('clientName'),
                      accountBalance: parseFloat(formData.get('accountBalance')) || 0,
                      commission: parseFloat(formData.get('commission')) || 0,
                      group: formData.get('group'),
                      adminNotes: formData.get('adminNotes') || ''
                    };

                    try {
                      const response = await api('/public/create-referral', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(referralData)
                      });

                      if (response.ok) {
                        alert('âœ… Referral created successfully!');
                        e.target.reset();
                        await fetchUserProfile(selectedUser, true); // Force refresh
                      } else {
                        const error = await response.json();
                        alert(`âŒ Error: ${error.message}`);
                      }
                    } catch (error) {
                      console.error('âŒ Error creating referral:', error);
                      alert('âŒ Network error occurred');
                    }
                  }}>
                    <div style={{ 
                      display: 'grid', 
                      gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', 
                      gap: '15px', 
                      alignItems: 'end' 
                    }}>
                      <div>
                        <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', marginBottom: '4px' }}>
                          Client Name *
                        </label>
                        <input
                          name="clientName"
                          type="text"
                          placeholder="Enter client name"
                          required
                          style={{
                            width: '100%',
                            padding: '8px',
                            border: '1px solid #d1d5db',
                            borderRadius: '4px',
                            fontSize: '14px'
                          }}
                        />
                      </div>
                      
                      <div>
                        <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', marginBottom: '4px' }}>
                          Account Balance
                        </label>
                        <input
                          name="accountBalance"
                          type="number"
                          placeholder="0"
                          min="0"
                          step="0.01"
                          style={{
                            width: '100%',
                            padding: '8px',
                            border: '1px solid #d1d5db',
                            borderRadius: '4px',
                            fontSize: '14px'
                          }}
                        />
                      </div>
                      
                      <div>
                        <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', marginBottom: '4px' }}>
                          Commission
                        </label>
                        <input
                          name="commission"
                          type="number"
                          placeholder="0"
                          min="0"
                          step="0.01"
                          style={{
                            width: '100%',
                            padding: '8px',
                            border: '1px solid #d1d5db',
                            borderRadius: '4px',
                            fontSize: '14px'
                          }}
                        />
                      </div>
                      
                      <div>
                        <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', marginBottom: '4px' }}>
                          Group
                        </label>
                        <select
                          name="group"
                          style={{
                            width: '100%',
                            padding: '8px',
                            border: '1px solid #d1d5db',
                            borderRadius: '4px',
                            fontSize: '14px'
                          }}
                        >
                          <option value="STANDARD">STANDARD</option>
                          <option value="VIP">VIP</option>
                          <option value="PREMIUM">PREMIUM</option>
                          <option value="GOLD">GOLD</option>
                          <option value="PRO">PRO</option>
                          <option value="ALGO_PREMIUM">ALGO_PREMIUM</option>
                        </select>
                      </div>
                      
                      <button
                        type="submit"
                        disabled={!selectedUser}
                        style={{
                          padding: '8px 16px',
                          background: selectedUser ? '#10b981' : '#9ca3af',
                          color: 'white',
                          border: 'none',
                          borderRadius: '4px',
                          cursor: selectedUser ? 'pointer' : 'not-allowed',
                          fontSize: '14px',
                          fontWeight: 'bold'
                        }}
                      >
                        âž• Add Referral
                      </button>
                    </div>
                    
                    <div style={{ marginTop: '10px' }}>
                      <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', marginBottom: '4px' }}>
                        Admin Notes (Optional)
                      </label>
                      <input
                        name="adminNotes"
                        type="text"
                        placeholder="Enter admin notes..."
                        style={{
                          width: '100%',
                          padding: '8px',
                          border: '1px solid #d1d5db',
                          borderRadius: '4px',
                          fontSize: '14px'
                        }}
                      />
                    </div>
                  </form>
                </div>

                {/* Bulk Add Section */}
                <div style={{ 
                  background: '#fff7ed', 
                  padding: '15px', 
                  borderRadius: '8px', 
                  border: '1px solid #fed7aa',
                  marginBottom: '20px'
                }}>
                  <h5 style={{ margin: '0 0 10px 0', color: '#9a3412' }}>ðŸ“‹ Bulk Operations</h5>
                  <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    <button
                      onClick={async () => {
                        if (!selectedUser) {
                          alert('âŒ No user selected');
                          return;
                        }
                        
                        const count = prompt('How many random referrals to create?', '10');
                        if (!count || parseInt(count) < 1) return;
                        
                        const referrals = [];
                        for (let i = 1; i <= parseInt(count); i++) {
                          referrals.push({
                            clientName: `Demo Client ${Date.now()}-${i}`,
                            accountBalance: Math.floor(Math.random() * 50000) + 1000,
                            commission: Math.floor(Math.random() * 500) + 50,
                            group: ['STANDARD', 'VIP', 'PREMIUM'][Math.floor(Math.random() * 3)]
                          });
                        }
                        
                        try {
                          const response = await api('/public/bulk-create-referrals', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ userId: selectedUser, referrals })
                          });
                          
                          if (response.ok) {
                            alert(`âœ… ${count} referrals created successfully!`);
                            await fetchUserProfile(selectedUser, true); // Force refresh
                          } else {
                            const error = await response.json();
                            alert(`âŒ Error: ${error.message}`);
                          }
                        } catch (error) {
                          console.error('âŒ Error creating bulk referrals:', error);
                          alert('âŒ Network error occurred');
                        }
                      }}
                      disabled={!selectedUser}
                      style={{
                        padding: '8px 12px',
                        background: selectedUser ? '#f59e0b' : '#9ca3af',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: selectedUser ? 'pointer' : 'not-allowed',
                        fontSize: '12px'
                      }}
                    >
                      ðŸŽ² Generate Random Referrals
                    </button>
                  </div>
                </div>

                {/* âœ… UPDATED: Referrals Table - without individual levels, with editing state management */}
                <div style={{ overflowX: 'auto' }}>
                  <table style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    fontSize: '14px',
                    background: 'white',
                    borderRadius: '8px',
                    overflow: 'hidden'
                  }}>
                    <thead>
                      <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                        <th style={{ padding: '12px', textAlign: 'left' }}>#</th>
                        <th style={{ padding: '12px', textAlign: 'left' }}>Client Name</th>
                        <th style={{ padding: '12px', textAlign: 'right' }}>Account Balance</th>
                        <th style={{ padding: '12px', textAlign: 'right' }}>Commission</th>
                        <th style={{ padding: '12px', textAlign: 'center' }}>Group</th>
                        <th style={{ padding: '12px', textAlign: 'center' }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!userProfile?.referralData?.referrals?.length ? (
                        <tr>
                          <td colSpan={6} style={{ 
                            textAlign: 'center', 
                            padding: '30px', 
                            color: '#6b7280', 
                            fontStyle: 'italic' 
                          }}>
                            No referrals found. Add some referrals using the form above.
                          </td>
                        </tr>
                      ) : (
                        userProfile.referralData.referrals.map((referral, index) => (
                          <tr key={referral._id || index} style={{ borderBottom: '1px solid #e5e7eb' }}>
                            <td style={{ padding: '12px', fontWeight: 'bold', color: '#374151' }}>
                              {index + 1}
                            </td>
                            <td style={{ padding: '12px' }}>
                              <input
                                type="text"
                                defaultValue={referral?.clientName || ''}
                                onFocus={() => handleEditingState()}
                                onBlur={async (e) => {
                                  if (referral?._id && e.target.value !== referral.clientName) {
                                    try {
                                      const response = await api(`/public/update-referral/${referral._id}`, {
                                        method: 'PUT',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({ clientName: e.target.value })
                                      });
                                      if (response.ok) {
                                        console.log('Client name updated');
                                      }
                                    } catch (error) {
                                      console.error('âŒ Error updating client name:', error);
                                    }
                                  }
                                }}
                                style={{
                                  width: '100%',
                                  padding: '4px 8px',
                                  border: '1px solid #d1d5db',
                                  borderRadius: '4px',
                                  fontSize: '14px'
                                }}
                              />
                            </td>
                            <td style={{ padding: '12px', textAlign: 'right' }}>
                              <input
                                type="number"
                                defaultValue={referral?.accountBalance || 0}
                                onFocus={() => handleEditingState()}
                                onBlur={async (e) => {
                                  const newValue = parseFloat(e.target.value) || 0;
                                  if (referral?._id && newValue !== referral.accountBalance) {
                                    try {
                                      const response = await api(`/public/update-referral/${referral._id}`, {
                                        method: 'PUT',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({ accountBalance: newValue })
                                      });
                                      if (response.ok) {
                                        console.log('Account balance updated');
                                      }
                                    } catch (error) {
                                      console.error('âŒ Error updating balance:', error);
                                    }
                                  }
                                }}
                                style={{
                                  width: '120px',
                                  padding: '4px 8px',
                                  border: '1px solid #d1d5db',
                                  borderRadius: '4px',
                                  fontSize: '14px',
                                  textAlign: 'right',
                                  fontWeight: 'bold'
                                }}
                                min="0"
                                step="0.01"
                              />
                            </td>
                            <td style={{ padding: '12px', textAlign: 'right' }}>
                              <input
                                type="number"
                                defaultValue={referral?.commission || 0}
                                onFocus={() => handleEditingState()}
                                onBlur={async (e) => {
                                  const newValue = parseFloat(e.target.value) || 0;
                                  if (referral?._id && newValue !== referral.commission) {
                                    try {
                                      const response = await api(`/public/update-referral/${referral._id}`, {
                                        method: 'PUT',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({ commission: newValue })
                                      });
                                      if (response.ok) {
                                        console.log('Commission updated');
                                      }
                                    } catch (error) {
                                      console.error('âŒ Error updating commission:', error);
                                    }
                                  }
                                }}
                                style={{
                                  width: '100px',
                                  padding: '4px 8px',
                                  border: '1px solid #d1d5db',
                                  borderRadius: '4px',
                                  fontSize: '14px',
                                  textAlign: 'right',
                                  fontWeight: 'bold',
                                  color: '#166534'
                                }}
                                min="0"
                                step="0.01"
                              />
                            </td>
                            <td style={{ padding: '12px', textAlign: 'center' }}>
                              <select
                                defaultValue={referral?.group || 'STANDARD'}
                                onFocus={() => handleEditingState()}
                                onChange={async (e) => {
                                  if (referral?._id) {
                                    try {
                                      const response = await api(`/public/update-referral/${referral._id}`, {
                                        method: 'PUT',
                                        headers: { 'Content-Type': 'application/json' },
                                        body: JSON.stringify({ group: e.target.value })
                                      });
                                      if (response.ok) {
                                        console.log('Group updated');
                                      }
                                    } catch (error) {
                                      console.error('âŒ Error updating group:', error);
                                    }
                                  }
                                }}
                                style={{
                                  padding: '4px 8px',
                                  border: '1px solid #d1d5db',
                                  borderRadius: '4px',
                                  fontSize: '12px',
                                  background: referral?.group?.includes('ALGO') ? '#ecfdf5' : '#f0f9ff',
                                  color: referral?.group?.includes('ALGO') ? '#166534' : '#1e40af'
                                }}
                              >
                                <option value="STANDARD">STANDARD</option>
                                <option value="VIP">VIP</option>
                                <option value="PREMIUM">PREMIUM</option>
                                <option value="GOLD">GOLD</option>
                                <option value="PRO">PRO</option>
                                <option value="ALGO_PREMIUM">ALGO_PREMIUM</option>
                              </select>
                            </td>
                            <td style={{ padding: '12px', textAlign: 'center' }}>
                              <button
                                onClick={async () => {
                                  if (referral?._id && confirm(`Delete referral "${referral.clientName}"?`)) {
                                    try {
                                      const response = await api(`/public/delete-referral/${referral._id}`, {
                                        method: 'DELETE'
                                      });
                                      if (response.ok) {
                                        alert('âœ… Referral deleted successfully!');
                                        await fetchUserProfile(selectedUser, true); // Force refresh
                                      }
                                    } catch (error) {
                                      console.error('âŒ Error deleting referral:', error);
                                      alert('âŒ Error deleting referral');
                                    }
                                  }
                                }}
                                style={{
                                  padding: '4px 8px',
                                  background: '#dc2626',
                                  color: 'white',
                                  border: 'none',
                                  borderRadius: '4px',
                                  cursor: 'pointer',
                                  fontSize: '12px'
                                }}
                                title="Delete Referral"
                              >
                                ðŸ—‘ï¸
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
const AllAccountsTradeHistory = ({ liveUserAccounts, api, onRefresh }) => {
  const totalTrades = liveUserAccounts.reduce((s, a) => s + (a.tradeHistory?.length || 0), 0);

  const editField = async (tradeId, field, currentVal) => {
    const isDate = field === 'openTime' || field === 'closeTime';
    const labels = { openPrice: 'Open Price', closePrice: 'Close Price', profit: 'Profit/Loss', commission: 'Commission', swap: 'Swap', volume: 'Volume', symbol: 'Symbol', openTime: 'Open Time (YYYY-MM-DDTHH:MM)', closeTime: 'Close Time (YYYY-MM-DDTHH:MM)' };
    const cur = isDate && currentVal ? new Date(currentVal).toISOString().slice(0, 16) : (currentVal ?? '');
    const val = window.prompt(`Edit ${labels[field] || field}:`, cur);
    if (val === null || val === '') return;
    const body = {};
    if (isDate) { body[field] = new Date(val).toISOString(); }
    else if (field === 'symbol') { body[field] = val; }
    else { body[field] = parseFloat(val); }
    try {
      const r = await api(`/public/edit-trade-history/${tradeId}`, { method: 'PUT', body: JSON.stringify(body) });
      if (r.ok) onRefresh();
      else { const d = await r.json(); alert('❌ ' + d.message); }
    } catch (e) { alert('Error: ' + e.message); }
  };

  const deleteTrade = async (tradeId, symbol) => {
    if (!window.confirm(`Delete trade ${symbol}? Cannot be undone.`)) return;
    try {
      const r = await api(`/public/delete-trade/${tradeId}`, { method: 'DELETE' });
      const d = await r.json();
      if (d.success) { alert('✅ Deleted!'); onRefresh(); }
      else alert('❌ ' + d.message);
    } catch (e) { alert('Error: ' + e.message); }
  };

  if (totalTrades === 0) return (
    <div style={{ padding: '40px', textAlign: 'center', background: '#f8fafc', borderRadius: '8px' }}>
      <h3 style={{ color: '#6b7280' }}>No closed trades yet</h3>
      <p style={{ color: '#9ca3af' }}>Closed trades appear here. Click any value to edit it.</p>
    </div>
  );

  return (
    <div>
      <div style={{ background: '#7c3aed', color: 'white', padding: '12px', borderRadius: '8px 8px 0 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontWeight: 'bold' }}>📊 ALL ACCOUNTS TRADE HISTORY — ADMIN EDITING ({totalTrades} trades)</span>
        <button onClick={onRefresh} style={{ background: 'rgba(255,255,255,0.2)', color: 'white', border: 'none', padding: '4px 10px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>🔄 Refresh</button>
      </div>
      <div style={{ background: '#f8fafc', borderRadius: '0 0 8px 8px', border: '1px solid #e5e7eb', padding: '15px' }}>
        {liveUserAccounts.map(account => {
          if (!account.tradeHistory || account.tradeHistory.length === 0) return null;
          return (
            <div key={account._id} style={{ marginBottom: '25px', background: 'white', borderRadius: '8px', padding: '15px', border: '1px solid #e5e7eb' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px', background: '#f1f5f9', padding: '10px 14px', borderRadius: '6px' }}>
                <h5 style={{ color: '#1e40af', margin: 0, fontSize: '15px', fontWeight: 'bold' }}>
                  {account.userId?.firstName} {account.userId?.lastName} — Account: {account.accountId}
                  <span style={{ marginLeft: '12px', fontSize: '11px', color: '#7c3aed', background: '#f3e8ff', padding: '2px 8px', borderRadius: '4px' }}>1:{account.leverage || 100}</span>
                </h5>
                <span style={{ background: '#10b981', color: 'white', padding: '4px 12px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold' }}>{account.tradeHistory.length} Trades</span>
              </div>
              <div style={{ overflowX: 'auto', maxHeight: '400px', overflowY: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                  <thead style={{ position: 'sticky', top: 0 }}>
                    <tr style={{ background: '#1976d2', color: 'white' }}>
                      <th style={{ padding: '8px 6px', border: '1px solid #1565c0' }}>Trade ID</th>
                      <th style={{ padding: '8px 6px', border: '1px solid #1565c0' }}>Symbol</th>
                      <th style={{ padding: '8px 6px', border: '1px solid #1565c0', textAlign: 'center' }}>Type</th>
                      <th style={{ padding: '8px 6px', border: '1px solid #1565c0', textAlign: 'right' }}>Volume</th>
                      <th style={{ padding: '8px 6px', border: '1px solid #1565c0', textAlign: 'right' }}>Open Price</th>
                      <th style={{ padding: '8px 6px', border: '1px solid #1565c0', textAlign: 'right' }}>Close Price</th>
                      <th style={{ padding: '8px 6px', border: '1px solid #1565c0', textAlign: 'right' }}>Profit/Loss</th>
                      <th style={{ padding: '8px 6px', border: '1px solid #1565c0', textAlign: 'right' }}>Commission</th>
                      <th style={{ padding: '8px 6px', border: '1px solid #1565c0', textAlign: 'right' }}>Swap</th>
                      <th style={{ padding: '8px 6px', border: '1px solid #1565c0', textAlign: 'center', minWidth: '130px' }}>Open Time ✏️</th>
                      <th style={{ padding: '8px 6px', border: '1px solid #1565c0', textAlign: 'center', minWidth: '130px' }}>Close Time ✏️</th>
                      <th style={{ padding: '8px 6px', border: '1px solid #1565c0', textAlign: 'center' }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {account.tradeHistory.map((trade, i) => (
                      <tr key={trade.tradeId || i} style={{ backgroundColor: trade.adminEdited ? '#fffde7' : (i % 2 === 0 ? '#f8fafc' : 'white'), borderBottom: '1px solid #e5e7eb' }}>
                        <td style={{ padding: '7px 6px', border: '1px solid #e5e7eb', fontWeight: 'bold', color: '#1e40af', fontSize: '11px' }}>
                          {String(trade.tradeId || '').slice(-8)}{trade.adminEdited && <span style={{ fontSize: '9px', color: '#f59e0b', marginLeft: '3px' }}>✏️</span>}
                        </td>
                        <td style={{ padding: '7px 6px', border: '1px solid #e5e7eb', fontWeight: 'bold', color: '#2e7d32' }}>
                          <span style={{ cursor: 'pointer' }} onClick={() => editField(trade.tradeId, 'symbol', trade.symbol)}>{trade.symbol} ✏️</span>
                        </td>
                        <td style={{ padding: '7px 6px', border: '1px solid #e5e7eb', textAlign: 'center', fontWeight: 'bold', color: (trade.type||'').toUpperCase()==='BUY'?'#16a34a':'#dc2626' }}>{(trade.type||'').toUpperCase()}</td>
                        <td style={{ padding: '7px 6px', border: '1px solid #e5e7eb', textAlign: 'right', color: '#e65100' }}>
                          <span style={{ cursor: 'pointer' }} onClick={() => editField(trade.tradeId, 'volume', trade.volume)}>{parseFloat(trade.volume||0).toFixed(2)} ✏️</span>
                        </td>
                        <td style={{ padding: '7px 6px', border: '1px solid #e5e7eb', textAlign: 'right', fontFamily: 'monospace' }}>
                          <span style={{ cursor: 'pointer', background: '#e3f2fd', padding: '1px 4px', borderRadius: '2px' }} onClick={() => editField(trade.tradeId, 'openPrice', trade.openPrice)}>{parseFloat(trade.openPrice||0).toFixed(5)} ✏️</span>
                        </td>
                        <td style={{ padding: '7px 6px', border: '1px solid #e5e7eb', textAlign: 'right', fontFamily: 'monospace' }}>
                          <span style={{ cursor: 'pointer', background: '#fce4ec', padding: '1px 4px', borderRadius: '2px' }} onClick={() => editField(trade.tradeId, 'closePrice', trade.closePrice)}>{parseFloat(trade.closePrice||0).toFixed(5)} ✏️</span>
                        </td>
                        <td style={{ padding: '7px 6px', border: '1px solid #e5e7eb', textAlign: 'right', fontWeight: 'bold' }}>
                          <span style={{ cursor: 'pointer', color: (trade.profit||0)>=0?'#16a34a':'#dc2626', background: (trade.profit||0)>=0?'#e8f5e8':'#ffebee', padding: '2px 5px', borderRadius: '3px' }} onClick={() => editField(trade.tradeId, 'profit', trade.profit)}>
                            ${parseFloat(trade.profit||0).toFixed(2)} ✏️
                          </span>
                        </td>
                        <td style={{ padding: '7px 6px', border: '1px solid #e5e7eb', textAlign: 'right', color: '#dc2626' }}>
                          <span style={{ cursor: 'pointer' }} onClick={() => editField(trade.tradeId, 'commission', trade.commission)}>-${Math.abs(trade.commission||0).toFixed(2)} ✏️</span>
                        </td>
                        <td style={{ padding: '7px 6px', border: '1px solid #e5e7eb', textAlign: 'right' }}>
                          <span style={{ cursor: 'pointer' }} onClick={() => editField(trade.tradeId, 'swap', trade.swap)}>${parseFloat(trade.swap||0).toFixed(2)} ✏️</span>
                        </td>
                        <td style={{ padding: '7px 6px', border: '1px solid #e5e7eb', textAlign: 'center', fontSize: '11px' }}>
                          <span style={{ cursor: 'pointer', color: '#1565c0' }} onClick={() => editField(trade.tradeId, 'openTime', trade.openTime)}>
                            {trade.openTime ? new Date(trade.openTime).toLocaleString() : '—'} ✏️
                          </span>
                        </td>
                        <td style={{ padding: '7px 6px', border: '1px solid #e5e7eb', textAlign: 'center', fontSize: '11px' }}>
                          <span style={{ cursor: 'pointer', color: '#1565c0' }} onClick={() => editField(trade.tradeId, 'closeTime', trade.closeTime)}>
                            {trade.closeTime ? new Date(trade.closeTime).toLocaleString() : '—'} ✏️
                          </span>
                        </td>
                        <td style={{ padding: '7px 6px', border: '1px solid #e5e7eb', textAlign: 'center' }}>
                          <button onClick={() => deleteTrade(trade.tradeId, trade.symbol)}
                            style={{ background: '#ef4444', color: 'white', border: 'none', padding: '3px 8px', borderRadius: '3px', fontSize: '10px', cursor: 'pointer' }}>
                            DELETE
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <p style={{ color: '#6b7280', margin: '8px 0 0', fontSize: '12px', textAlign: 'center' }}>Showing all {account.tradeHistory.length} trades — Click any value to edit</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
/* â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ HELPER COMPONENTS â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€ */
/* âœ… NEW: Trade History Manager Component */
const TradeHistoryManager = ({ userId, userProfile, onRefresh }) => {
  const [tradeHistory, setTradeHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingTradeId, setEditingTradeId] = useState(null);
  const [editValues, setEditValues] = useState({});
  const [selectedTrades, setSelectedTrades] = useState([]);

  const api = (path, opts = {}) => {
    const token = localStorage.getItem("userToken");
    // âœ… WORKING PATTERN:
const API_BASE_URL = "https://final-project-5ar7.onrender.com";
    
    return fetch(`${API_BASE_URL}/api/admin/${path}`, {
      ...opts,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
        ...opts.headers,
      },
    });
  };

  const fetchTradeHistory = async () => {
    try {
      setLoading(true);
      const response = await api(`public/user-trade-history/${userId}`);
      const data = await response.json();
      
      if (data.success) {
        setTradeHistory(data.tradeHistory);
        console.log(`Loaded ${data.tradeHistory.length} trade history records`);
      } else {
        console.error('âŒ Failed to fetch trade history:', data.message);
        setTradeHistory([]);
      }
    } catch (error) {
      console.error('âŒ Error fetching trade history:', error);
      setTradeHistory([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchTradeHistory();
    }
  }, [userId]);

  const startEditingTrade = (trade) => {
    setEditingTradeId(trade._id);
    setEditValues({
      openPrice: trade.openPrice,
      closePrice: trade.closePrice,
      profit: trade.profit,
      commission: trade.commission,
      swap: trade.swap,
      stopLoss: trade.stopLoss || 0,
      takeProfit: trade.takeProfit || 0
    });
  };

  const saveTradeEdits = async (mongoId) => {
  try {
    // Find the custom tradeId from the trade whose _id matches
    const trade = tradeHistory.find(t => t._id === mongoId);
    if (!trade || !trade.tradeId) {
      alert('❌ Trade is missing tradeId — cannot edit');
      return;
    }
    const response = await api(`public/edit-trade-history/${trade.tradeId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...editValues,   // flat fields: openPrice, profit, etc.
        adminNotes: `Trade edited by admin on ${new Date().toLocaleString()}`
      })
    });

      if (response.ok) {
        alert('âœ… Trade updated successfully!');
        setEditingTradeId(null);
        setEditValues({});
        await fetchTradeHistory();
        if (onRefresh) onRefresh();
      } else {
        const error = await response.json();
        alert(`âŒ Error: ${error.message}`);
      }
    } catch (error) {
      console.error('âŒ Error saving trade:', error);
      alert('âŒ Network error occurred');
    }
  };

  const cancelEdit = () => {
    setEditingTradeId(null);
    setEditValues({});
  };

  const toggleSelectTrade = (tradeId) => {
    setSelectedTrades(prev => 
      prev.includes(tradeId) 
        ? prev.filter(id => id !== tradeId)
        : [...prev, tradeId]
    );
  };

  const bulkEditTrades = async () => {
    if (selectedTrades.length === 0) {
      alert('âŒ Please select trades to edit');
      return;
    }

    const newProfit = prompt('Enter new profit for all selected trades:', '0');
    if (newProfit === null) return;

    const adminNotes = prompt('Admin notes (optional):', '');

    try {
      const response = await api('public/bulk-edit-trades', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tradeIds: selectedTrades,
          updates: { profit: parseFloat(newProfit) },
          adminNotes: adminNotes || `Bulk edit: profit set to ${newProfit}`
        })
      });

      if (response.ok) {
        const result = await response.json();
        alert(`âœ… ${result.updatedCount} trades updated successfully!`);
        setSelectedTrades([]);
        await fetchTradeHistory();
        if (onRefresh) onRefresh();
      } else {
        const error = await response.json();
        alert(`âŒ Error: ${error.message}`);
      }
    } catch (error) {
      console.error('âŒ Error bulk editing:', error);
      alert('âŒ Network error occurred');
    }
  };

  if (loading) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <div className="loading-spinner"></div>
        <p>Loading trade history...</p>
      </div>
    );
  }

  return (
    <div style={{ background: '#f8fafc', borderRadius: '8px', padding: '20px' }}>
      {/* Header with bulk actions */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        marginBottom: '20px',
        background: 'white',
        padding: '15px',
        borderRadius: '6px',
        border: '1px solid #e5e7eb'
      }}>
        <div>
          <h3 style={{ margin: 0, color: '#1f2937' }}>
            ðŸ“Š Trade History Manager ({tradeHistory.length} records)
          </h3>
          <p style={{ margin: '5px 0 0 0', fontSize: '14px', color: '#6b7280' }}>
            Click on any trade to edit â€¢ Select multiple trades for bulk operations
          </p>
        </div>
        
        <div style={{ display: 'flex', gap: '10px' }}>
          <button
            onClick={() => fetchTradeHistory()}
            style={{
              background: '#3b82f6',
              color: 'white',
              border: 'none',
              padding: '8px 12px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '12px'
            }}
          >
            ðŸ”„ Refresh
          </button>
          
          {selectedTrades.length > 0 && (
            <>
              <button
                onClick={bulkEditTrades}
                style={{
                  background: '#f59e0b',
                  color: 'white',
                  border: 'none',
                  padding: '8px 12px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '12px'
                }}
              >
                ðŸ› ï¸ Bulk Edit ({selectedTrades.length})
              </button>
              <button
                onClick={() => setSelectedTrades([])}
                style={{
                  background: '#6b7280',
                  color: 'white',
                  border: 'none',
                  padding: '8px 12px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '12px'
                }}
              >
                Clear Selection
              </button>
            </>
          )}
        </div>
      </div>

      {/* Trade History Table */}
      {tradeHistory.length === 0 ? (
        <div style={{ 
          padding: '40px', 
          textAlign: 'center', 
          background: 'white', 
          borderRadius: '6px',
          border: '1px solid #e5e7eb'
        }}>
          <h4 style={{ color: '#6b7280', margin: '0 0 10px 0' }}>No Trade History Found</h4>
          <p style={{ color: '#9ca3af', margin: 0, fontSize: '14px' }}>
            This user hasn't closed any trades yet, or all trade history has been cleared.
          </p>
        </div>
      ) : (
        <div style={{ 
          background: 'white', 
          borderRadius: '6px', 
          overflow: 'hidden',
          border: '1px solid #e5e7eb'
        }}>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
              <thead>
                <tr style={{ background: '#1976d2', color: 'white' }}>
                  <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: 'bold' }}>
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedTrades(tradeHistory.map(t => t._id));
                        } else {
                          setSelectedTrades([]);
                        }
                      }}
                      checked={selectedTrades.length === tradeHistory.length && tradeHistory.length > 0}
                    />
                  </th>
                  <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: 'bold' }}>Order ID</th>
                  <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: 'bold' }}>Account</th>
                  <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: 'bold' }}>Symbol</th>
                  <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: 'bold' }}>Type</th>
                  <th style={{ padding: '12px 8px', textAlign: 'right', fontWeight: 'bold' }}>Volume</th>
                  <th style={{ padding: '12px 8px', textAlign: 'right', fontWeight: 'bold' }}>Open Price</th>
                  <th style={{ padding: '12px 8px', textAlign: 'right', fontWeight: 'bold' }}>Close Price</th>
                  <th style={{ padding: '12px 8px', textAlign: 'right', fontWeight: 'bold' }}>Profit</th>
                  <th style={{ padding: '12px 8px', textAlign: 'right', fontWeight: 'bold' }}>Commission</th>
                  <th style={{ padding: '12px 8px', textAlign: 'right', fontWeight: 'bold' }}>Swap</th>
                  <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: 'bold' }}>Duration</th>
                  <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: 'bold' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {tradeHistory.map((trade, index) => (
                  <tr 
                    key={trade._id} 
                    style={{ 
                      borderBottom: '1px solid #e5e7eb',
                      backgroundColor: editingTradeId === trade._id ? '#fef3c7' : (index % 2 === 0 ? '#f8fafc' : 'white')
                    }}
                  >
                    <td style={{ padding: '10px 8px', textAlign: 'center' }}>
                      <input
                        type="checkbox"
                        checked={selectedTrades.includes(trade._id)}
                        onChange={() => toggleSelectTrade(trade._id)}
                      />
                    </td>
                    
                    <td style={{ padding: '10px 8px', fontWeight: 'bold', color: '#1e40af' }}>
                      {String(trade.tradeId || 'N/A').slice(-8)}
                      {trade.adminEdited && <span style={{ fontSize: '10px', color: '#f59e0b', marginLeft: '4px' }}>âœï¸</span>}
                    </td>
                    
                    <td style={{ padding: '10px 8px', color: '#374151' }}>
                      #{trade.accountId}
                    </td>
                    
                    <td style={{ padding: '10px 8px', fontWeight: 'bold', color: '#2e7d32' }}>
                      {trade.symbol}
                    </td>
                    
                    <td style={{ 
                      padding: '10px 8px', 
                      textAlign: 'center', 
                      fontWeight: 'bold',
                      color: trade.type === 'BUY' ? '#4caf50' : '#f44336'
                    }}>
                      {trade.type}
                    </td>
                    
                    <td style={{ padding: '10px 8px', textAlign: 'right', fontWeight: 'bold' }}>
                      {parseFloat(trade.volume || 0).toFixed(2)}
                    </td>
                    
                    {/* Editable Open Price */}
                    <td style={{ padding: '10px 8px', textAlign: 'right' }}>
                      {editingTradeId === trade._id ? (
                        <input
                          type="number"
                          value={editValues.openPrice}
                          onChange={(e) => setEditValues({...editValues, openPrice: parseFloat(e.target.value)})}
                          style={{
                            width: '80px',
                            padding: '4px',
                            border: '2px solid #3b82f6',
                            borderRadius: '4px',
                            textAlign: 'right',
                            background: '#eff6ff'
                          }}
                          step="0.00001"
                        />
                      ) : (
                        <span style={{ fontFamily: 'monospace' }}>
                          {parseFloat(trade.openPrice || 0).toFixed(5)}
                        </span>
                      )}
                    </td>
                    
                    {/* Editable Close Price */}
                    <td style={{ padding: '10px 8px', textAlign: 'right' }}>
                      {editingTradeId === trade._id ? (
                        <input
                          type="number"
                          value={editValues.closePrice}
                          onChange={(e) => setEditValues({...editValues, closePrice: parseFloat(e.target.value)})}
                          style={{
                            width: '80px',
                            padding: '4px',
                            border: '2px solid #7c3aed',
                            borderRadius: '4px',
                            textAlign: 'right',
                            background: '#f3e8ff'
                          }}
                          step="0.00001"
                        />
                      ) : (
                        <span style={{ fontFamily: 'monospace' }}>
                          {parseFloat(trade.closePrice || 0).toFixed(5)}
                        </span>
                      )}
                    </td>
                    
                    {/* Editable Profit */}
                    <td style={{ padding: '10px 8px', textAlign: 'right' }}>
                      {editingTradeId === trade._id ? (
                        <input
                          type="number"
                          value={editValues.profit}
                          onChange={(e) => setEditValues({...editValues, profit: parseFloat(e.target.value)})}
                          style={{
                            width: '80px',
                            padding: '4px',
                            border: '2px solid #dc2626',
                            borderRadius: '4px',
                            textAlign: 'right',
                            background: '#fef2f2',
                            fontWeight: 'bold'
                          }}
                          step="0.01"
                        />
                      ) : (
                        <span style={{ 
                          fontWeight: 'bold', 
                          color: (trade.profit || 0) >= 0 ? '#4caf50' : '#f44336'
                        }}>
                          ${parseFloat(trade.profit || 0).toFixed(2)}
                        </span>
                      )}
                    </td>
                    
                    {/* Editable Commission */}
                    <td style={{ padding: '10px 8px', textAlign: 'right' }}>
                      {editingTradeId === trade._id ? (
                        <input
                          type="number"
                          value={editValues.commission}
                          onChange={(e) => setEditValues({...editValues, commission: parseFloat(e.target.value)})}
                          style={{
                            width: '60px',
                            padding: '4px',
                            border: '1px solid #d1d5db',
                            borderRadius: '4px',
                            textAlign: 'right'
                          }}
                          step="0.01"
                        />
                      ) : (
                        <span style={{ color: '#dc2626', fontSize: '12px' }}>
                          ${Math.abs(trade.commission || 0).toFixed(2)}
                        </span>
                      )}
                    </td>
                    
                    {/* Editable Swap */}
                    <td style={{ padding: '10px 8px', textAlign: 'right' }}>
                      {editingTradeId === trade._id ? (
                        <input
                          type="number"
                          value={editValues.swap}
                          onChange={(e) => setEditValues({...editValues, swap: parseFloat(e.target.value)})}
                          style={{
                            width: '60px',
                            padding: '4px',
                            border: '1px solid #d1d5db',
                            borderRadius: '4px',
                            textAlign: 'right'
                          }}
                          step="0.01"
                        />
                      ) : (
                        <span style={{ 
                          color: (trade.swap || 0) >= 0 ? '#4caf50' : '#f44336',
                          fontSize: '12px'
                        }}>
                          ${parseFloat(trade.swap || 0).toFixed(2)}
                        </span>
                      )}
                    </td>
                    
                    <td style={{ padding: '10px 8px', textAlign: 'center', fontSize: '11px', color: '#6b7280' }}>
                      {trade.duration || 0} min
                    </td>
                    
                    {/* Action Buttons */}
                    <td style={{ padding: '10px 8px', textAlign: 'center' }}>
                      {editingTradeId === trade._id ? (
                        <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
                          <button
                            onClick={() => saveTradeEdits(trade._id)}
                            style={{
                              background: '#10b981',
                              color: 'white',
                              border: 'none',
                              padding: '4px 8px',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '10px'
                            }}
                          >
                            âœ… Save
                          </button>
                          <button
                            onClick={cancelEdit}
                            style={{
                              background: '#6b7280',
                              color: 'white',
                              border: 'none',
                              padding: '4px 8px',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '10px'
                            }}
                          >
                            âŒ Cancel
                          </button>
                        </div>
                      ) : (
                        <button
                          onClick={() => startEditingTrade(trade)}
                          style={{
                            background: '#3b82f6',
                            color: 'white',
                            border: 'none',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '10px'
                          }}
                        >
                          âœï¸ Edit
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

const TabButton = ({ active, onClick, count, children }) => (
  <button
    onClick={onClick}
    style={{
      padding: '12px 20px',
      background: active ? '#3b82f6' : 'transparent',
      color: active ? 'white' : '#6b7280',
      border: 'none',
      borderRadius: '6px 6px 0 0',
      cursor: 'pointer',
      fontWeight: active ? 'bold' : 'normal',
      fontSize: '14px'
    }}
  >
    {children} ({count})
  </button>
);

const Section = ({ title, color, count, children }) => (
  <section style={{ marginBottom: 40 }}>
    <h2 style={{ color }}>{title} ({count})</h2>
    {children}
  </section>
);

const Empty = ({ msg }) => (
  <div style={{ padding: 20, background: "#f9fafb", borderRadius: 8 }}>
    <p>{msg}</p>
  </div>
);

const StatCard = ({ title, value, color, bgColor, editable, onClick }) => (
  <div 
    style={{ 
      background: bgColor, 
      padding: '15px', 
      borderRadius: '8px', 
      textAlign: 'center',
      cursor: editable ? 'pointer' : 'default'
    }}
    onClick={onClick}
  >
    <h4 style={{ margin: '0 0 5px 0', color }}>{title}</h4>
    <p style={{ fontSize: '18px', fontWeight: 'bold', margin: 0, color }}>
      {value}
      {editable && <span style={{ fontSize: '12px', marginLeft: '5px' }}>âœï¸</span>}
    </p>
  </div>
);

const DocumentCard = ({ title, fileName, fileUrl, bgColor, buttonColor }) => (
  <div style={{ padding: '12px', background: bgColor, borderRadius: '6px' }}>
    <h5 style={{ margin: '0 0 8px 0' }}>{title}</h5>
    <p style={{ margin: '0 0 8px 0', fontSize: '12px' }}>
      <strong>File:</strong> {fileName}
    </p>
    {fileUrl ? (
      <a href={fileUrl} target="_blank" rel="noopener noreferrer"
        style={{ color: 'white', background: buttonColor, padding: '6px 10px',
          textDecoration: 'none', borderRadius: '4px', fontSize: '12px', display: 'inline-block' }}>
        📄 View Document
      </a>
    ) : (
      <span style={{ color: '#9ca3af', fontSize: '12px' }}>No file URL available</span>
    )}
  </div>
);

const CardGrid = ({ users, onApprove, onReject, onViewProfile, acctInfo, showDate }) => (
  <div className={styles.userGrid}>
    {users.map(u => {
      const a = acctInfo(u.accountType);
      return (
        <div key={u._id} className={styles.userCard}>
          <header className={styles.cardHead}>
            <div>
              <h3>{u.firstName} {u.lastName}</h3>
              <small>{u.email}</small>
            </div>
            <span style={{ background: a.c }} className={styles.badge}>{a.i} {a.l}</span>
          </header>

          <ul className={styles.details}>
            <li><strong>Phone:</strong> {u.phone || "â€”"}</li>
            <li><strong>Country:</strong> {u.country || "â€”"}</li>
            <li><strong>Registered:</strong> {showDate(u.registeredAt)}</li>
          </ul>

          <footer className={styles.actions}>
            <button onClick={() => onApprove(u._id)} className={styles.approveBtn}>
              âœ… Approve
            </button>
            <button onClick={() => onReject(u._id)} className={styles.rejectBtn}>
              âŒ Reject
            </button>
            <button
              onClick={() => onViewProfile(u._id)}
              style={{
                background: '#6366f1',
                color: 'white',
                border: 'none',
                padding: '8px 12px',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '12px',
                marginTop: '5px'
              }}
            >
              ðŸ“‹ View Profile
            </button>
          </footer>
        </div>
      );
    })}
  </div>
);

const Table = ({ users, kycProfiles, acctInfo, showDate, onBal, onType, onViewProfile, onSyncBalance, onDelete }) => (
  <table className={styles.userTable}>
    <thead>
      <tr>
        <th>Name</th>
        <th>Email</th>
        <th>Account Type</th>
        <th>User Balance</th>
        <th>Trading Balance</th>
        <th>KYC Status</th>
        <th>Registered</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      {users.map(u => {
        const a = acctInfo(u.accountType);
        const hasKyc = kycProfiles.find(kyc => kyc.userId._id === u._id);
        return (
          <tr key={u._id}>
            <td>{u.firstName} {u.lastName}</td>
            <td>{u.email}</td>
            <td>
              <span style={{ background: a.c }} className={styles.tag}>
                {a.i} {a.l}
              </span>
            </td>
            <td>
              <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <span>${(u.balance || 0).toLocaleString()}</span>
              </div>
            </td>
            <td>
              <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <span>${(u.tradingAccountBalance || 0).toLocaleString()}</span>
                {Math.abs((u.balance || 0) - (u.tradingAccountBalance || 0)) > 0.01 && (
                  <span 
                    title="Balances don't match - click to sync"
                    style={{ 
                      cursor: 'pointer', 
                      fontSize: '16px',
                      color: '#f59e0b'
                    }}
                    onClick={() => onSyncBalance(u._id, u.balance || 0, u.tradingAccountBalance || 0)}
                  >
                    âš ï¸
                  </span>
                )}
              </div>
            </td>
            <td>
              {hasKyc ? (
                <span style={{ color: '#10b981', fontWeight: 'bold', fontSize: '12px' }}>âœ… Verified</span>
              ) : (
                <span style={{ color: '#6b7280', fontSize: '12px' }}>âŒ Not Verified</span>
              )}
            </td>
            <td>{showDate(u.registeredAt)}</td>
            <td>
              <div className={styles.tableBtns}>
                <button
                  onClick={() => onBal(u._id, u.balance)}
                  title="Update Balance"
                >
                  ðŸ’° Bal
                </button>
                <button
                  onClick={() => onType(u._id, u.accountType)}
                  title="Update Account Type"
                >
                  ðŸ·ï¸ Type
                </button>
                <button
  onClick={() => onViewProfile(u._id)}
  title="View Complete Profile"
  style={{ background: '#6366f1', color: 'white' }}
>
  📋 Profile
</button>
<button
  onClick={() => onDelete(u._id, `${u.firstName} ${u.lastName}`)}
  title="Delete User Permanently"
  style={{ background: '#dc2626', color: 'white' }}
>
  🗑️ Delete
</button>
              </div>
            </td>
          </tr>
        );
      })}
    </tbody>
  </table>
);

const KycTable = ({ kycProfiles, onViewProfile, onResetPin, newPin, setNewPin, showDate }) => (
  <table className={styles.userTable}>
    <thead>
      <tr>
        <th>User</th>
        <th>Full Name</th>
        <th>WhatsApp</th>
        <th>Status</th>
        <th>Current PIN</th>
        <th>Verified Date</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      {kycProfiles.map(kyc => (
        <tr key={kyc._id}>
          <td>
            <div>
              <div style={{ fontWeight: 'bold' }}>{kyc.userId.firstName} {kyc.userId.lastName}</div>
              <div style={{ fontSize: '12px', color: '#6b7280' }}>{kyc.userId.email}</div>
            </div>
          </td>
          <td>{kyc.fullName}</td>
          <td>{kyc.whatsappNumber}</td>
          <td>
            {kyc.isKycApproved ? (
              <span style={{ background: '#d1fae5', color: '#065f46', padding: '3px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold' }}>✅ Approved</span>
            ) : kyc.isKycRejected ? (
              <span style={{ background: '#fee2e2', color: '#991b1b', padding: '3px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold' }}>❌ Rejected</span>
            ) : (
              <span style={{ background: '#fef3c7', color: '#92400e', padding: '3px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 'bold' }}>⏳ Pending</span>
            )}
          </td>
          <td>
            <span style={{
              background: '#fee2e2',
              color: '#991b1b',
              padding: '4px 8px',
              borderRadius: '4px',
              fontFamily: 'monospace',
              fontWeight: 'bold',
              fontSize: '12px'
            }}>
              {kyc.withdrawalPin}
            </span>
          </td>
          <td>{showDate(kyc.firstApprovedAt)}</td>
          <td>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              {/* Approve with PIN */}
              {!kyc.isKycApproved && !kyc.isKycRejected && (
                <button
                  onClick={async () => {
                    const pin = prompt('Set withdrawal PIN for this user (4-6 digits):');
                    if (!pin || pin.length < 4) { alert('PIN must be at least 4 digits'); return; }
                    if (!confirm(`Approve KYC for ${kyc.fullName} with PIN: ${pin}?`)) return;
                    try {
                      const res = await fetch(`${API_BASE_URL}/api/admin/public/approve-kyc/${kyc.userId._id}`, {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ withdrawalPin: pin })
                      });
                      const data = await res.json();
                      if (data.success) { alert('✅ KYC Approved!'); window.location.reload(); }
                      else alert(`❌ ${data.message}`);
                    } catch(e) { alert('❌ Network error'); }
                  }}
                  style={{ background: '#10b981', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}
                >
                  ✅ Approve
                </button>
              )}
              {/* Reject */}
              {!kyc.isKycApproved && (
                <button
                  onClick={async () => {
                    const reason = prompt('Reason for rejection:');
                    if (!confirm(`Reject KYC for ${kyc.fullName}?`)) return;
                    try {
                      const res = await fetch(`${API_BASE_URL}/api/admin/public/reject-kyc/${kyc.userId._id}`, {
                        method: 'PUT',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ reason: reason || 'Rejected by admin' })
                      });
                      const data = await res.json();
                      if (data.success) { alert('❌ KYC Rejected'); window.location.reload(); }
                      else alert(`❌ ${data.message}`);
                    } catch(e) { alert('❌ Network error'); }
                  }}
                  style={{ background: '#ef4444', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}
                >
                  ❌ Reject
                </button>
              )}
              {/* PIN Reset (only for approved) */}
              {kyc.isKycApproved && (
                <div style={{ display: 'flex', gap: '4px' }}>
                  <input type="text" placeholder="New PIN" value={newPin[kyc._id] || ''} onChange={e => setNewPin(p => ({...p, [kyc._id]: e.target.value}))}
                    style={{ width: '70px', padding: '4px', fontSize: '12px', border: '1px solid #d1d5db', borderRadius: '4px' }} />
                  <button onClick={() => onResetPin(kyc._id, kyc.userId._id)}
                    style={{ background: '#3b82f6', color: 'white', border: 'none', padding: '4px 8px', borderRadius: '4px', cursor: 'pointer', fontSize: '11px' }}>
                    🔄 PIN
                  </button>
                </div>
              )}
              <button onClick={() => onViewProfile(kyc.userId._id)}
                style={{ background: '#6366f1', color: 'white', border: 'none', padding: '4px 8px', borderRadius: '4px', cursor: 'pointer', fontSize: '11px' }}>
                📋 Profile
              </button>
            </div>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);
